var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaskGroup152({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 475,
    height: 335,
    viewBox: "0 0 475 335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19529",
    "data-name": "Rectangle 19529",
    width: 475,
    height: 335,
    transform: "translate(1016 372)",
    opacity: 0.452
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18647",
    "data-name": "Rectangle 18647",
    width: 481.353,
    height: 300.035,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18615",
    "data-name": "Rectangle 18615",
    width: 10.45,
    height: 22.255,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18616",
    "data-name": "Rectangle 18616",
    width: 19.531,
    height: 12.222,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18618",
    "data-name": "Rectangle 18618",
    width: 10.45,
    height: 22.256,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18639",
    "data-name": "Rectangle 18639",
    width: 1.644,
    height: 1.667,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18643",
    "data-name": "Rectangle 18643",
    width: 57.823,
    height: 20.348,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_152",
    "data-name": "Mask Group 152",
    transform: "translate(-1016 -372)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44516",
    "data-name": "Group 44516",
    transform: "translate(1016 389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44515",
    "data-name": "Group 44515",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18594",
    "data-name": "Rectangle 18594",
    width: 22.11,
    height: 43.825,
    transform: "translate(378.309 40.497)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18595",
    "data-name": "Rectangle 18595",
    width: 23.889,
    height: 43.825,
    transform: "translate(401.269 40.497)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18596",
    "data-name": "Rectangle 18596",
    width: 23.889,
    height: 42.345,
    transform: "translate(401.269 87.385)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138405",
    "data-name": "Path 138405",
    d: "M608.347,0V39.739H633.5V.863h.85V39.739h20.474V0Z",
    transform: "translate(-180.127 0)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18597",
    "data-name": "Rectangle 18597",
    width: 20.474,
    height: 43.825,
    transform: "translate(454.228 40.498)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18598",
    "data-name": "Rectangle 18598",
    width: 20.474,
    height: 42.345,
    transform: "translate(454.228 87.385)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18599",
    "data-name": "Rectangle 18599",
    width: 22.11,
    height: 42.345,
    transform: "translate(378.309 87.385)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18600",
    "data-name": "Rectangle 18600",
    width: 25.158,
    height: 42.345,
    transform: "translate(428.22 87.385)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18601",
    "data-name": "Rectangle 18601",
    width: 22.11,
    height: 38.157,
    transform: "translate(378.309 130.488)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18602",
    "data-name": "Rectangle 18602",
    width: 20.474,
    height: 38.157,
    transform: "translate(454.228 130.488)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138406",
    "data-name": "Path 138406",
    d: "M537.443,0V39.739h22.109V.863h.85V39.739h23.889V0Z",
    transform: "translate(-159.133 0)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18603",
    "data-name": "Rectangle 18603",
    width: 25.158,
    height: 38.157,
    transform: "translate(428.22 130.488)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18604",
    "data-name": "Rectangle 18604",
    width: 23.889,
    height: 38.157,
    transform: "translate(401.269 130.488)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18605",
    "data-name": "Rectangle 18605",
    width: 25.158,
    height: 43.825,
    transform: "translate(428.22 40.497)",
    fill: "#7476b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18606",
    "data-name": "Rectangle 18606",
    width: 54.544,
    height: 90.287,
    transform: "translate(303.863 10.349)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18607",
    "data-name": "Rectangle 18607",
    width: 54.544,
    height: 90.287,
    transform: "translate(302.049 10.349)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18608",
    "data-name": "Rectangle 18608",
    width: 49.899,
    height: 86.625,
    transform: "translate(304.372 12.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18609",
    "data-name": "Rectangle 18609",
    width: 30.684,
    height: 64.113,
    transform: "translate(313.871 23.436)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44474",
    "data-name": "Group 44474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44473",
    "data-name": "Group 44473",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138407",
    "data-name": "Path 138407",
    d: "M445.9,82.2c-.071-5.989,5.314-11.836,11.245-12.672,2.828-.4,5.833.163,8.475-.921,4.716-1.934,6.217-8.2,10.964-10.06l.217,46.339H445.9Z",
    transform: "translate(-132.027 -17.334)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44476",
    "data-name": "Group 44476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44475",
    "data-name": "Group 44475",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138408",
    "data-name": "Path 138408",
    d: "M485.364,424.3c0,.1-105.629.183-235.9.183-130.315,0-235.921-.082-235.921-.183s105.606-.183,235.921-.183c130.269,0,235.9.082,235.9.183",
    transform: "translate(-4.011 -125.579)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18612",
    "data-name": "Rectangle 18612",
    width: 250.336,
    height: 50.712,
    transform: "translate(169.729 248.012)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18613",
    "data-name": "Rectangle 18613",
    width: 285.092,
    height: 5.831,
    transform: "translate(152.351 245.147)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44478",
    "data-name": "Group 44478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44477",
    "data-name": "Group 44477",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138409",
    "data-name": "Path 138409",
    d: "M502.061,356.442c0,.1-63.561.183-141.951.183-78.417,0-141.965-.082-141.965-.183s63.548-.183,141.965-.183c78.389,0,141.951.082,141.951.183",
    transform: "translate(-64.591 -105.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138410",
    "data-name": "Path 138410",
    d: "M491.943,401.024c0,.1-55.948.183-124.947.183-69.023,0-124.959-.082-124.959-.183s55.936-.183,124.959-.183c69,0,124.947.082,124.947.183",
    transform: "translate(-71.665 -118.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138411",
    "data-name": "Path 138411",
    d: "M491.26,377.508c0,.1-55.948.183-124.947.183-69.023,0-124.959-.082-124.959-.183s55.936-.183,124.959-.183c69,0,124.947.082,124.947.183",
    transform: "translate(-71.463 -111.723)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44492",
    "data-name": "Group 44492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44491",
    "data-name": "Group 44491",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138412",
    "data-name": "Path 138412",
    d: "M303.1,305.272s-2.445-16.814-2.242-26.6-.012-20.787-.012-20.787h1.127s-.763,19.417.068,31.128,3.017,16.255,3.017,16.255Z",
    transform: "translate(-89.079 -76.359)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138413",
    "data-name": "Path 138413",
    d: "M309.655,230.265a2.972,2.972,0,0,0-1.027-1.5,2.86,2.86,0,0,0-2.45.018c-3.405,1.2-6.424,7.553-7.8,10.892L302.9,254.9c8.159-7.57,9.572-17.5,6.756-24.638",
    transform: "translate(-88.348 -67.654)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138414",
    "data-name": "Path 138414",
    d: "M310.265,229.752a.9.9,0,0,1-.065.2l-.222.555c-.2.479-.476,1.176-.808,2.041-.667,1.729-1.514,4.148-2.272,6.872s-1.275,5.236-1.6,7.061c-.161.913-.282,1.653-.36,2.166-.039.24-.071.435-.1.59a.9.9,0,0,1-.046.2.826.826,0,0,1,.008-.209l.062-.595c.055-.516.157-1.261.3-2.178a64.76,64.76,0,0,1,3.876-13.959c.348-.861.645-1.551.864-2.022l.253-.541a.881.881,0,0,1,.1-.184",
    transform: "translate(-90.248 -68.028)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138415",
    "data-name": "Path 138415",
    d: "M299.008,261.84a13.793,13.793,0,0,1-6.967-11.581c-.163-3.38.876-6.7,2.052-9.87a1.271,1.271,0,0,1,.479-.716,1.216,1.216,0,0,1,1.155.179c3.079,1.753,4.945,5.1,5.937,8.5a17.152,17.152,0,0,1,.7,6.987,11.608,11.608,0,0,1-3.353,6.5",
    transform: "translate(-86.466 -70.939)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138416",
    "data-name": "Path 138416",
    d: "M300.682,262.885a.858.858,0,0,1-.017-.2c0-.154-.006-.348-.011-.585,0-.508-.023-1.242-.064-2.147a58.66,58.66,0,0,0-.786-7.037c-.47-2.728-1.04-5.171-1.461-6.937-.208-.864-.377-1.572-.5-2.091-.053-.232-.1-.42-.13-.57a.819.819,0,0,1-.033-.2.857.857,0,0,1,.07.192c.043.148.1.334.164.562.139.489.332,1.2.559,2.077.453,1.759,1.045,4.2,1.517,6.938a51.428,51.428,0,0,1,.734,7.062c.025.909.025,1.645,0,2.153-.01.237-.018.431-.024.585a.859.859,0,0,1-.021.2",
    transform: "translate(-88.14 -71.984)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44481",
    "data-name": "Group 44481",
    transform: "translate(205.558 168.646)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44480",
    "data-name": "Group 44480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44479",
    "data-name": "Group 44479",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138417",
    "data-name": "Path 138417",
    d: "M299.008,261.84a13.793,13.793,0,0,1-6.967-11.581c-.163-3.38.876-6.7,2.052-9.87a1.271,1.271,0,0,1,.479-.716,1.216,1.216,0,0,1,1.155.179c3.079,1.753,4.945,5.1,5.937,8.5a17.152,17.152,0,0,1,.7,6.987,11.608,11.608,0,0,1-3.353,6.5",
    transform: "translate(-292.024 -239.585)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_138418",
    "data-name": "Path 138418",
    d: "M308.738,307.6c4.171.916,7.6,3.857,11.627,5.288,2.662.946,5.672,1.281,7.8,3.142a6.605,6.605,0,0,0-2.893-2.878,51.9,51.9,0,0,0-10.539-5.032,10.026,10.026,0,0,0-5.875-.661",
    transform: "translate(-91.415 -90.971)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138419",
    "data-name": "Path 138419",
    d: "M293.475,310.71c-5.222-.084-10.722-4.53-15.92-4.8,5.441-1.757,13.23-.322,15.92,4.8",
    transform: "translate(-82.182 -90.367)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138420",
    "data-name": "Path 138420",
    d: "M303.071,292.553a16.993,16.993,0,0,1,8.35-.568,50.779,50.779,0,0,1,8.151,2.215c-.267-1.812-1.735-3.175-3.114-4.38a21.719,21.719,0,0,0-3.272-2.516,7.29,7.29,0,0,0-3.926-1.107,6.2,6.2,0,0,0-4.333,2.184,7.2,7.2,0,0,0-1.855,4.173",
    transform: "translate(-89.737 -84.739)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138421",
    "data-name": "Path 138421",
    d: "M282.547,285.989c-3.288-2.807-8.267-2.533-12.589-2.435a102.524,102.524,0,0,1,19.524,12.166c.175-3.055-2.782-6.186-6.935-9.731",
    transform: "translate(-79.933 -83.942)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44484",
    "data-name": "Group 44484",
    transform: "translate(190.026 199.557)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44483",
    "data-name": "Group 44483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44482",
    "data-name": "Group 44482",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138422",
    "data-name": "Path 138422",
    d: "M282.547,285.989c-3.288-2.807-8.267-2.533-12.589-2.435a102.524,102.524,0,0,1,19.524,12.166c.175-3.055-2.782-6.186-6.935-9.731",
    transform: "translate(-269.959 -283.499)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_138423",
    "data-name": "Path 138423",
    d: "M305.165,275.852a36.57,36.57,0,0,1,5.055-2.939c1.731-.786,3.344-2.039,5.016-2.944a54.563,54.563,0,0,0,6.033-4.259,15.676,15.676,0,0,1,6.608-3.153,12.988,12.988,0,0,0-6.013.348,38.816,38.816,0,0,0-5.66,2.2,27.589,27.589,0,0,0-7.271,4.215c-2.1,1.875-3.99,3.726-3.769,6.53",
    transform: "translate(-90.352 -77.679)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138424",
    "data-name": "Path 138424",
    d: "M318.454,311.371a.653.653,0,0,1-.165-.071l-.455-.236c-.393-.209-.958-.52-1.669-.876-.352-.187-.742-.38-1.166-.579s-.874-.413-1.356-.622a19.838,19.838,0,0,0-3.215-1.121,6.9,6.9,0,0,0-3.35-.084,9.511,9.511,0,0,0-1.42.424,7.2,7.2,0,0,0-1.146.588,7.288,7.288,0,0,0-1.439,1.189c-.3.324-.45.523-.463.512a.627.627,0,0,1,.094-.153,4.779,4.779,0,0,1,.315-.407,6.729,6.729,0,0,1,1.423-1.252,7.082,7.082,0,0,1,1.159-.62,9.406,9.406,0,0,1,1.438-.448,6.97,6.97,0,0,1,3.433.07,19.051,19.051,0,0,1,3.241,1.145c.483.214.938.425,1.355.641s.81.406,1.159.6c.705.373,1.261.7,1.644.93l.439.267a.65.65,0,0,1,.146.1",
    transform: "translate(-89.6 -91.028)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138425",
    "data-name": "Path 138425",
    d: "M294.638,309.35a1.2,1.2,0,0,1,.327.1,7.47,7.47,0,0,1,.851.37,10.335,10.335,0,0,1,4.363,4.192,7.354,7.354,0,0,1,.4.836,1.172,1.172,0,0,1,.108.323c-.03.013-.225-.429-.626-1.092a11.563,11.563,0,0,0-4.311-4.142c-.679-.374-1.128-.552-1.116-.582",
    transform: "translate(-87.24 -91.596)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138426",
    "data-name": "Path 138426",
    d: "M278.222,286.665a1.071,1.071,0,0,1,.222.065l.627.223.988.365c.385.144.8.355,1.276.563a30.158,30.158,0,0,1,6.8,4.332,33.171,33.171,0,0,1,3.17,3.123,34.856,34.856,0,0,1,2.25,2.851c.6.845,1.049,1.549,1.359,2.035l.357.56a1.128,1.128,0,0,1,.116.2,1.111,1.111,0,0,1-.146-.18c-.091-.122-.224-.3-.387-.542-.329-.474-.8-1.166-1.4-2s-1.371-1.794-2.272-2.814a34.664,34.664,0,0,0-3.163-3.094A31.823,31.823,0,0,0,281.28,288c-.468-.215-.881-.434-1.261-.586l-.974-.393-.614-.256a1.086,1.086,0,0,1-.21-.1",
    transform: "translate(-82.38 -84.879)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138427",
    "data-name": "Path 138427",
    d: "M310.616,290.9a1.855,1.855,0,0,1-.417-.053l-.479-.089c-.187-.036-.4-.037-.642-.062a6.574,6.574,0,0,0-3.589.709,6.486,6.486,0,0,0-1.633,1.211,7.416,7.416,0,0,0-1.05,1.3,10.9,10.9,0,0,0-.718,1.37,1.564,1.564,0,0,1,.106-.407,5.882,5.882,0,0,1,.5-1.033,6.936,6.936,0,0,1,1.04-1.349,6.352,6.352,0,0,1,5.356-1.931c.24.033.46.044.647.09l.479.12a1.8,1.8,0,0,1,.4.125",
    transform: "translate(-89.445 -86.023)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138428",
    "data-name": "Path 138428",
    d: "M315.764,267.926a1.087,1.087,0,0,1-.2.122l-.582.317c-.507.273-1.236.676-2.122,1.2s-1.92,1.178-3.025,1.969a25.283,25.283,0,0,0-3.378,2.83,8.567,8.567,0,0,0-1.381,1.789c-.342.657-.669,1.292-.97,1.9a34.578,34.578,0,0,0-1.451,3.3,20.105,20.105,0,0,0-.705,2.326c-.134.559-.182.874-.2.871a1.051,1.051,0,0,1,.021-.231c.019-.151.051-.373.108-.656a17.364,17.364,0,0,1,.652-2.355,31.8,31.8,0,0,1,1.421-3.334c.3-.614.622-1.252.962-1.91a8.653,8.653,0,0,1,1.41-1.834,24.537,24.537,0,0,1,3.413-2.84c1.116-.786,2.166-1.426,3.058-1.942s1.637-.9,2.155-1.149l.6-.286a1.091,1.091,0,0,1,.215-.088",
    transform: "translate(-89.345 -79.331)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138429",
    "data-name": "Path 138429",
    d: "M299.388,285.821a2.077,2.077,0,0,1-.1-.44c-.061-.322-.137-.726-.229-1.207a30.876,30.876,0,0,0-2.479-7.676l-.509-1.118a2.127,2.127,0,0,1-.168-.42,2.116,2.116,0,0,1,.232.388c.139.256.334.628.564,1.094a25.787,25.787,0,0,1,2.489,7.709c.082.514.141.93.171,1.219a2.12,2.12,0,0,1,.032.451",
    transform: "translate(-87.614 -81.414)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138430",
    "data-name": "Path 138430",
    d: "M294.3,267.181a14.161,14.161,0,0,0-1.7-5.638,18.611,18.611,0,0,0-12.615-9.408l11.679,17.408,1.508,3.107a8.93,8.93,0,0,0,1.126-5.469",
    transform: "translate(-82.901 -74.655)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18617",
    "data-name": "Rectangle 18617",
    width: 27.159,
    height: 4.813,
    transform: "translate(200.992 226.833)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138431",
    "data-name": "Path 138431",
    d: "M288.419,327.73l2.312,14.936h18.03l2.76-14.936Z",
    transform: "translate(-85.399 -97.039)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138432",
    "data-name": "Path 138432",
    d: "M312.589,329.055c0,.053-6.126.1-13.681.1s-13.682-.043-13.682-.1,6.125-.1,13.682-.1,13.681.043,13.681.1",
    transform: "translate(-84.453 -97.402)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138433",
    "data-name": "Path 138433",
    d: "M33.143,379.861s-2.445-16.814-2.242-26.6-.012-20.788-.012-20.788h1.127s-.763,19.417.068,31.128S35.1,379.861,35.1,379.861Z",
    transform: "translate(-9.146 -98.444)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138434",
    "data-name": "Path 138434",
    d: "M39.7,304.855a2.972,2.972,0,0,0-1.027-1.5,2.86,2.86,0,0,0-2.45.018c-3.406,1.2-6.424,7.553-7.8,10.892l4.52,15.232c8.159-7.57,9.572-17.5,6.756-24.638",
    transform: "translate(-8.415 -89.74)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138435",
    "data-name": "Path 138435",
    d: "M40.306,304.342a.9.9,0,0,1-.065.2l-.222.555c-.2.479-.476,1.176-.808,2.041-.667,1.729-1.514,4.148-2.272,6.872s-1.275,5.236-1.6,7.061c-.161.913-.282,1.653-.36,2.166-.039.239-.071.435-.1.59a.9.9,0,0,1-.046.2.826.826,0,0,1,.008-.209c.016-.156.037-.353.062-.595.055-.516.157-1.261.3-2.178a64.78,64.78,0,0,1,3.876-13.96c.348-.86.645-1.551.864-2.022l.253-.541a.884.884,0,0,1,.1-.184",
    transform: "translate(-10.315 -90.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138436",
    "data-name": "Path 138436",
    d: "M29.049,336.43a13.793,13.793,0,0,1-6.967-11.581c-.163-3.38.876-6.7,2.052-9.87a1.271,1.271,0,0,1,.479-.716,1.216,1.216,0,0,1,1.155.179c3.079,1.753,4.945,5.1,5.937,8.5a17.152,17.152,0,0,1,.7,6.987,11.608,11.608,0,0,1-3.353,6.5",
    transform: "translate(-6.533 -93.025)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138437",
    "data-name": "Path 138437",
    d: "M30.723,337.475a.861.861,0,0,1-.017-.2c0-.154-.006-.348-.011-.585,0-.508-.022-1.242-.063-2.147a58.654,58.654,0,0,0-.786-7.037c-.47-2.728-1.04-5.171-1.461-6.937-.208-.864-.377-1.572-.5-2.091-.053-.232-.1-.42-.13-.57a.816.816,0,0,1-.033-.2.859.859,0,0,1,.07.192c.043.149.1.334.164.562.139.489.332,1.2.559,2.077.453,1.759,1.045,4.2,1.517,6.938a51.437,51.437,0,0,1,.734,7.062c.025.909.025,1.645,0,2.153-.009.237-.017.431-.023.585a.86.86,0,0,1-.021.2",
    transform: "translate(-8.207 -94.069)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44487",
    "data-name": "Group 44487",
    transform: "translate(15.532 221.149)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44486",
    "data-name": "Group 44486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44485",
    "data-name": "Group 44485",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138438",
    "data-name": "Path 138438",
    d: "M29.049,336.43a13.793,13.793,0,0,1-6.967-11.581c-.163-3.38.876-6.7,2.052-9.87a1.271,1.271,0,0,1,.479-.716,1.216,1.216,0,0,1,1.155.179c3.079,1.753,4.945,5.1,5.937,8.5a17.152,17.152,0,0,1,.7,6.987,11.608,11.608,0,0,1-3.353,6.5",
    transform: "translate(-22.065 -314.174)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_138439",
    "data-name": "Path 138439",
    d: "M38.779,382.188c4.171.916,7.6,3.857,11.627,5.288,2.662.947,5.672,1.281,7.8,3.142a6.6,6.6,0,0,0-2.893-2.878,51.9,51.9,0,0,0-10.539-5.032,10.025,10.025,0,0,0-5.875-.661",
    transform: "translate(-11.482 -113.057)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138440",
    "data-name": "Path 138440",
    d: "M23.516,385.3c-5.222-.084-10.721-4.53-15.92-4.8,5.44-1.757,13.23-.322,15.92,4.8",
    transform: "translate(-2.249 -112.452)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138441",
    "data-name": "Path 138441",
    d: "M33.112,367.143a16.993,16.993,0,0,1,8.35-.568,50.769,50.769,0,0,1,8.151,2.215c-.267-1.812-1.735-3.175-3.114-4.38a21.721,21.721,0,0,0-3.272-2.516,7.29,7.29,0,0,0-3.926-1.107,6.2,6.2,0,0,0-4.333,2.184,7.2,7.2,0,0,0-1.855,4.173",
    transform: "translate(-9.804 -106.825)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138442",
    "data-name": "Path 138442",
    d: "M12.589,360.579C9.3,357.772,4.322,358.047,0,358.144a102.516,102.516,0,0,1,19.524,12.166c.176-3.055-2.781-6.186-6.934-9.732",
    transform: "translate(0 -106.027)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44490",
    "data-name": "Group 44490",
    transform: "translate(0 252.061)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44489",
    "data-name": "Group 44489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44488",
    "data-name": "Group 44488",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138443",
    "data-name": "Path 138443",
    d: "M12.589,360.579C9.3,357.772,4.322,358.047,0,358.144a102.516,102.516,0,0,1,19.524,12.166c.176-3.055-2.781-6.186-6.934-9.732",
    transform: "translate(0 -358.089)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_138444",
    "data-name": "Path 138444",
    d: "M35.206,350.442a36.538,36.538,0,0,1,5.056-2.939c1.73-.786,3.344-2.038,5.016-2.944a54.7,54.7,0,0,0,6.033-4.259,15.67,15.67,0,0,1,6.608-3.153,12.987,12.987,0,0,0-6.013.348,38.744,38.744,0,0,0-5.66,2.2,27.606,27.606,0,0,0-7.271,4.214c-2.1,1.876-3.991,3.727-3.769,6.531",
    transform: "translate(-10.419 -99.764)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138445",
    "data-name": "Path 138445",
    d: "M48.5,385.96a.657.657,0,0,1-.165-.071l-.455-.237c-.393-.209-.958-.52-1.669-.876-.352-.187-.742-.38-1.166-.579s-.874-.413-1.356-.622a19.884,19.884,0,0,0-3.216-1.121,6.909,6.909,0,0,0-3.35-.084,9.5,9.5,0,0,0-1.42.424,7.2,7.2,0,0,0-1.146.588,7.311,7.311,0,0,0-1.439,1.189c-.3.325-.45.523-.463.512a.627.627,0,0,1,.094-.153,4.786,4.786,0,0,1,.315-.407,6.727,6.727,0,0,1,1.423-1.252,7.082,7.082,0,0,1,1.159-.62,9.412,9.412,0,0,1,1.438-.448,6.972,6.972,0,0,1,3.433.07,19.05,19.05,0,0,1,3.241,1.145c.483.214.938.425,1.355.64s.81.406,1.159.6c.705.373,1.261.7,1.644.93l.439.267a.627.627,0,0,1,.146.1",
    transform: "translate(-9.667 -113.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138446",
    "data-name": "Path 138446",
    d: "M24.679,383.94a1.2,1.2,0,0,1,.327.1,7.467,7.467,0,0,1,.851.37,10.335,10.335,0,0,1,4.364,4.192,7.352,7.352,0,0,1,.4.836,1.225,1.225,0,0,1,.109.323c-.03.013-.225-.429-.626-1.092a11.564,11.564,0,0,0-4.311-4.142c-.679-.374-1.128-.552-1.116-.582",
    transform: "translate(-7.307 -113.681)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138447",
    "data-name": "Path 138447",
    d: "M8.263,361.255a1.075,1.075,0,0,1,.222.065l.627.223.988.365c.385.144.8.355,1.276.563a30.159,30.159,0,0,1,6.8,4.332,33.161,33.161,0,0,1,3.17,3.123,35.013,35.013,0,0,1,2.25,2.851c.6.845,1.049,1.549,1.359,2.035l.357.56a1.125,1.125,0,0,1,.116.2,1.108,1.108,0,0,1-.146-.18c-.092-.122-.224-.3-.387-.541-.329-.475-.8-1.166-1.4-2s-1.371-1.794-2.272-2.814a34.736,34.736,0,0,0-3.163-3.094,31.85,31.85,0,0,0-6.734-4.355c-.468-.215-.881-.434-1.261-.586l-.974-.393-.614-.256a1.084,1.084,0,0,1-.21-.1",
    transform: "translate(-2.447 -106.965)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138448",
    "data-name": "Path 138448",
    d: "M40.657,365.491a1.847,1.847,0,0,1-.417-.053l-.479-.089c-.187-.036-.4-.037-.642-.062A6.575,6.575,0,0,0,35.53,366a6.471,6.471,0,0,0-1.633,1.211,7.418,7.418,0,0,0-1.05,1.3,10.716,10.716,0,0,0-.717,1.37,1.506,1.506,0,0,1,.106-.407,5.886,5.886,0,0,1,.5-1.033,6.935,6.935,0,0,1,1.04-1.349,6.353,6.353,0,0,1,5.356-1.931c.24.033.46.044.648.09l.478.12a1.8,1.8,0,0,1,.4.125",
    transform: "translate(-9.513 -108.108)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138449",
    "data-name": "Path 138449",
    d: "M45.806,342.515a1.078,1.078,0,0,1-.2.122l-.583.317c-.506.272-1.235.676-2.122,1.2s-1.92,1.178-3.025,1.969a25.279,25.279,0,0,0-3.378,2.83,8.568,8.568,0,0,0-1.381,1.789c-.342.657-.669,1.292-.97,1.9a34.582,34.582,0,0,0-1.451,3.3,20.111,20.111,0,0,0-.705,2.326c-.134.559-.182.874-.2.871a1.054,1.054,0,0,1,.021-.232c.019-.151.051-.372.108-.655a17.352,17.352,0,0,1,.653-2.355A31.8,31.8,0,0,1,34,352.564c.3-.614.622-1.252.962-1.91a8.656,8.656,0,0,1,1.41-1.834,24.539,24.539,0,0,1,3.413-2.84c1.116-.786,2.166-1.426,3.058-1.942s1.637-.9,2.155-1.149l.6-.286a1.087,1.087,0,0,1,.215-.088",
    transform: "translate(-9.413 -101.416)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138450",
    "data-name": "Path 138450",
    d: "M29.429,360.411a2.077,2.077,0,0,1-.1-.44c-.061-.322-.137-.726-.229-1.207a33.871,33.871,0,0,0-.988-3.919,34.3,34.3,0,0,0-1.492-3.757l-.509-1.118a2.127,2.127,0,0,1-.168-.42,2.113,2.113,0,0,1,.232.388c.139.255.334.628.564,1.094a27.33,27.33,0,0,1,1.549,3.757,27.282,27.282,0,0,1,.94,3.952c.082.514.14.93.17,1.219a2.121,2.121,0,0,1,.032.451",
    transform: "translate(-7.681 -103.499)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138451",
    "data-name": "Path 138451",
    d: "M24.339,341.771a14.161,14.161,0,0,0-1.7-5.638,18.612,18.612,0,0,0-12.615-9.408L21.7,344.133l1.508,3.107a8.93,8.93,0,0,0,1.126-5.469",
    transform: "translate(-2.968 -96.741)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18620",
    "data-name": "Rectangle 18620",
    width: 27.159,
    height: 4.813,
    transform: "translate(10.965 279.337)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138452",
    "data-name": "Path 138452",
    d: "M18.46,402.32l2.312,14.936H38.8l2.76-14.936Z",
    transform: "translate(-5.466 -119.124)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138453",
    "data-name": "Path 138453",
    d: "M42.63,403.645c0,.053-6.126.1-13.681.1s-13.682-.043-13.682-.1,6.124-.1,13.682-.1,13.681.042,13.681.1",
    transform: "translate(-4.52 -119.488)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18622",
    "data-name": "Rectangle 18622",
    width: 172.125,
    height: 142.482,
    transform: "translate(40.315 7.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44494",
    "data-name": "Group 44494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44493",
    "data-name": "Group 44493",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138454",
    "data-name": "Path 138454",
    d: "M229.338,153.07c0-.993-.047-56.617-.119-142.482l.119.119-172.11.023h-.015l.141-.142c-.006,51.579-.011,100.255-.015,142.482l-.126-.127,172.125.127L57.213,153.2h-.127v-.127c0-42.227-.01-90.9-.015-142.482v-.142h.157l172.11.023h.119v.119c-.072,85.865-.118,141.49-.119,142.482",
    transform: "translate(-16.898 -3.093)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138455",
    "data-name": "Path 138455",
    d: "M250.947,137.355H195.63a1.726,1.726,0,0,1-1.727-1.727v-.439a1.726,1.726,0,0,1,1.727-1.727h55.317a1.726,1.726,0,0,1,1.727,1.727v.439a1.726,1.726,0,0,1-1.727,1.727",
    transform: "translate(-57.413 -39.517)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138456",
    "data-name": "Path 138456",
    d: "M250.947,148.785H195.63a1.726,1.726,0,0,1-1.727-1.727v-.439a1.726,1.726,0,0,1,1.727-1.727h55.317a1.726,1.726,0,0,1,1.727,1.727v.439a1.726,1.726,0,0,1-1.727,1.727",
    transform: "translate(-57.413 -42.902)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138457",
    "data-name": "Path 138457",
    d: "M224.683,159.365H195.629a1.727,1.727,0,0,1-1.727-1.727V157.2a1.727,1.727,0,0,1,1.727-1.727h29.054a1.726,1.726,0,0,1,1.727,1.727v.439a1.726,1.726,0,0,1-1.727,1.727",
    transform: "translate(-57.413 -46.034)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138458",
    "data-name": "Path 138458",
    d: "M227.848,17.453H54.444a4.658,4.658,0,0,1-4.658-4.658V11.609a4.658,4.658,0,0,1,4.658-4.658h173.4a4.658,4.658,0,0,1,4.658,4.658v1.185a4.658,4.658,0,0,1-4.658,4.658",
    transform: "translate(-14.741 -2.058)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138459",
    "data-name": "Path 138459",
    d: "M154.066,135.789c0,.041-15.964.073-35.652.073s-35.656-.032-35.656-.073,15.961-.073,35.656-.073,35.652.033,35.652.073",
    transform: "translate(-24.504 -40.185)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138460",
    "data-name": "Path 138460",
    d: "M154.066,146.975c0,.041-15.964.073-35.652.073s-35.656-.032-35.656-.073,15.961-.073,35.656-.073,35.652.032,35.652.073",
    transform: "translate(-24.504 -43.497)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138461",
    "data-name": "Path 138461",
    d: "M154.066,158.161c0,.041-15.964.073-35.652.073s-35.656-.032-35.656-.073,15.961-.073,35.656-.073,35.652.032,35.652.073",
    transform: "translate(-24.504 -46.809)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138462",
    "data-name": "Path 138462",
    d: "M154.066,169.347c0,.041-15.964.073-35.652.073s-35.656-.032-35.656-.073,15.961-.073,35.656-.073,35.652.032,35.652.073",
    transform: "translate(-24.504 -50.121)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138463",
    "data-name": "Path 138463",
    d: "M154.066,180.533c0,.041-15.964.073-35.652.073s-35.656-.032-35.656-.073,15.961-.073,35.656-.073,35.652.032,35.652.073",
    transform: "translate(-24.504 -53.433)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18623",
    "data-name": "Rectangle 18623",
    width: 7.104,
    height: 22.874,
    transform: "translate(102.039 112.027)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18624",
    "data-name": "Rectangle 18624",
    width: 7.104,
    height: 30.43,
    transform: "translate(115.454 104.47)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18625",
    "data-name": "Rectangle 18625",
    width: 7.104,
    height: 10.706,
    transform: "translate(64.643 124.194)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18626",
    "data-name": "Rectangle 18626",
    width: 7.104,
    height: 13.901,
    transform: "translate(76.396 121)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18627",
    "data-name": "Rectangle 18627",
    width: 7.104,
    height: 17.944,
    transform: "translate(88.576 116.956)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138464",
    "data-name": "Path 138464",
    d: "M154.616,171.957s-.111,0-.327.006l-.96.006-3.686.012-13.561.02-44.741.019H82.427v-.063c.01-13.254.018-24.963.025-33.362.009-4.2.017-7.566.022-9.888.006-1.159.01-2.055.013-2.666q0-.454.007-.691c0-.155.006-.234.006-.234s0,.08.007.234,0,.389.007.691c0,.61.007,1.507.013,2.666,0,2.323.013,5.692.022,9.888.006,8.4.015,20.108.025,33.362l-.073-.063h8.842l44.741.019,13.561.02,3.686.012.96.006c.215,0,.327.006.327.006",
    transform: "translate(-24.406 -37.046)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138465",
    "data-name": "Path 138465",
    d: "M86.059,141.439a10.649,10.649,0,0,1-1.765.073,10.637,10.637,0,0,1-1.764-.073,10.63,10.63,0,0,1,1.764-.073,10.642,10.642,0,0,1,1.765.073",
    transform: "translate(-24.437 -41.857)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138466",
    "data-name": "Path 138466",
    d: "M86.059,152.081a10.642,10.642,0,0,1-1.765.073,10.63,10.63,0,0,1-1.764-.073,10.723,10.723,0,0,1,1.764-.073,10.735,10.735,0,0,1,1.765.073",
    transform: "translate(-24.437 -45.008)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138467",
    "data-name": "Path 138467",
    d: "M86.059,162.723a10.643,10.643,0,0,1-1.765.073,10.631,10.631,0,0,1-1.764-.073,10.633,10.633,0,0,1,1.764-.073,10.645,10.645,0,0,1,1.765.073",
    transform: "translate(-24.437 -48.16)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138468",
    "data-name": "Path 138468",
    d: "M86.059,173.364a10.646,10.646,0,0,1-1.765.073,10.634,10.634,0,0,1-1.764-.073,10.634,10.634,0,0,1,1.764-.073,10.646,10.646,0,0,1,1.765.073",
    transform: "translate(-24.437 -51.31)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138469",
    "data-name": "Path 138469",
    d: "M199.479,49.584H146.592a2.566,2.566,0,0,1-2.566-2.566v-.653a2.567,2.567,0,0,1,2.566-2.566h52.887a2.566,2.566,0,0,1,2.566,2.566v.653a2.566,2.566,0,0,1-2.566,2.566",
    transform: "translate(-42.645 -12.969)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138470",
    "data-name": "Path 138470",
    d: "M214.267,71.3H84.153a1.727,1.727,0,0,1-1.727-1.727v-.439A1.727,1.727,0,0,1,84.153,67.4H214.267a1.726,1.726,0,0,1,1.727,1.727v.439a1.726,1.726,0,0,1-1.727,1.727",
    transform: "translate(-24.406 -19.958)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138471",
    "data-name": "Path 138471",
    d: "M214.267,84.487H84.153a1.727,1.727,0,0,1-1.727-1.727v-.439a1.727,1.727,0,0,1,1.727-1.727H214.267a1.726,1.726,0,0,1,1.727,1.727v.439a1.726,1.726,0,0,1-1.727,1.727",
    transform: "translate(-24.406 -23.863)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138472",
    "data-name": "Path 138472",
    d: "M214.267,97.676H84.153a1.727,1.727,0,0,1-1.727-1.727V95.51a1.727,1.727,0,0,1,1.727-1.727H214.267a1.726,1.726,0,0,1,1.727,1.727v.439a1.726,1.726,0,0,1-1.727,1.727",
    transform: "translate(-24.406 -27.768)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138473",
    "data-name": "Path 138473",
    d: "M112.5,110.865H83.442a1.727,1.727,0,0,1-1.727-1.727V108.7a1.727,1.727,0,0,1,1.727-1.727H112.5a1.726,1.726,0,0,1,1.727,1.727v.439a1.726,1.726,0,0,1-1.727,1.727",
    transform: "translate(-24.195 -31.674)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44496",
    "data-name": "Group 44496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44495",
    "data-name": "Group 44495",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138474",
    "data-name": "Path 138474",
    d: "M625.894,170.712l-1.42-5.007a16.568,16.568,0,1,1,5.743,1.5l.008,0Z",
    transform: "translate(-182.077 -39.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138475",
    "data-name": "Path 138475",
    d: "M625.849,170.652s.1-.087.284-.243l.825-.686,3.18-2.624.02.113-.008,0a.066.066,0,0,1-.041-.084.068.068,0,0,1,.068-.044,16.546,16.546,0,0,0,7.981-1.424,16.141,16.141,0,0,0,4.371-2.917,16.387,16.387,0,0,0-6.765-27.866,16.182,16.182,0,0,0-7.869-.2,16.677,16.677,0,0,0-6.784,3.252,16.333,16.333,0,0,0-4.407,5.549,16.461,16.461,0,0,0,7.753,22.115.066.066,0,0,1,.034.041l1.012,3.715.26.97c.058.22.086.34.086.34s-.034-.1-.1-.308-.161-.538-.283-.945c-.253-.861-.622-2.113-1.1-3.736l.034.04a16.475,16.475,0,0,1-6.341-5.139,16.689,16.689,0,0,1,2.867-22.867,16.946,16.946,0,0,1,6.9-3.319,16.463,16.463,0,0,1,8.014.2,16.633,16.633,0,0,1,6.841,28.329,16.259,16.259,0,0,1-4.444,2.931,16.549,16.549,0,0,1-8.073,1.372l.027-.128.008,0a.066.066,0,0,1,.042.083.073.073,0,0,1-.022.03l-3.268,2.59-.829.652c-.185.144-.275.209-.275.209",
    transform: "translate(-182.033 -39.67)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138476",
    "data-name": "Path 138476",
    d: "M631.88,150.635h2.466a2.1,2.1,0,0,1,2.152-2.108,2,2,0,0,1,1.932,1.273,2.209,2.209,0,0,1-.176,2,2.675,2.675,0,0,1-3,1.024v5.56H637.7v-3.257a4.762,4.762,0,0,0,3.42-4.653,4.432,4.432,0,0,0-4.618-4.444c-1.059,0-4.665.255-4.618,4.606",
    transform: "translate(-187.095 -43.238)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18629",
    "data-name": "Rectangle 18629",
    width: 2.475,
    height: 2.312,
    transform: "translate(448.156 116.29)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44498",
    "data-name": "Group 44498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44497",
    "data-name": "Group 44497",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138477",
    "data-name": "Path 138477",
    d: "M408.534,59.535l2.3-3.989a14.659,14.659,0,1,1,2.588,4.569l0,.008Z",
    transform: "translate(-120.964 -10.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138478",
    "data-name": "Path 138478",
    d: "M408.534,59.484s.115.008.329.03l.945.1,3.625.4-.06.082,0-.008a.058.058,0,0,1,.1-.062,14.642,14.642,0,0,0,5.826,4.185,14.256,14.256,0,0,0,4.546.974,14.467,14.467,0,0,0,10.224-3.463,14.463,14.463,0,0,0,3.283-18.015,14.336,14.336,0,0,0-4.725-5.117,14.763,14.763,0,0,0-6.246-2.3,14.444,14.444,0,0,0-6.239.626,14.565,14.565,0,0,0-9.248,18.557.056.056,0,0,1,0,.046l-1.732,2.933-.455.764c-.1.172-.163.264-.163.264s.042-.082.135-.252.242-.434.425-.762l1.691-3,0,.046a14.578,14.578,0,0,1-.65-7.191A14.763,14.763,0,0,1,426.4,36.038a14.993,14.993,0,0,1,6.362,2.331,14.57,14.57,0,0,1,4.813,5.209,14.717,14.717,0,0,1-13.752,21.811,14.384,14.384,0,0,1-4.6-1.012,14.637,14.637,0,0,1-5.85-4.276l.1-.062,0,.008a.058.058,0,0,1-.027.077.057.057,0,0,1-.032,0l-3.657-.476-.925-.124c-.206-.028-.3-.046-.3-.046",
    transform: "translate(-120.964 -10.64)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138479",
    "data-name": "Path 138479",
    d: "M424.741,56.364a1.391,1.391,0,1,1-1.4-1.38,1.391,1.391,0,0,1,1.4,1.38",
    transform: "translate(-124.939 -16.28)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138480",
    "data-name": "Path 138480",
    d: "M432.646,56.3a1.391,1.391,0,1,1-1.4-1.38,1.391,1.391,0,0,1,1.4,1.38",
    transform: "translate(-127.28 -16.262)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138481",
    "data-name": "Path 138481",
    d: "M440.6,55.542a1.391,1.391,0,1,1-1.9-.494,1.39,1.39,0,0,1,1.9.494",
    transform: "translate(-129.693 -16.243)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_138482",
    "data-name": "Path 138482",
    d: "M598.427,403.914V391.75l10.062-.635-.631,13.1-4.78,1.868Z",
    transform: "translate(-177.19 -115.807)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44500",
    "data-name": "Group 44500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44499",
    "data-name": "Group 44499",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138483",
    "data-name": "Path 138483",
    d: "M599.551,409.515l-4.007-.218s-6.164,4.989-6.758,7.726a6.143,6.143,0,0,0,0,2.1l9.361.272c1.885,0,6.829.008,6.829.008v-9.8Z",
    transform: "translate(-174.308 -121.19)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138484",
    "data-name": "Path 138484",
    d: "M589.391,348.81c.025.567,4.818,35.556,4.818,35.556l12.145.029-.31-36.313Z",
    transform: "translate(-174.514 -103.064)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18632",
    "data-name": "Rectangle 18632",
    width: 16.276,
    height: 1.699,
    transform: "translate(414.377 296.883)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138485",
    "data-name": "Path 138485",
    d: "M599,410.378c.1.03-.327,1.7-.664,3.795s-.469,3.813-.576,3.81a18.251,18.251,0,0,1,1.241-7.6",
    transform: "translate(-176.972 -121.51)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138486",
    "data-name": "Path 138486",
    d: "M607.2,418.965a8.54,8.54,0,0,0-.848-1.541,4.536,4.536,0,0,0-1.426-1.2,4.346,4.346,0,0,0-4.355.206,4.527,4.527,0,0,0-1.307,1.331,8.434,8.434,0,0,0-.7,1.613,1.021,1.021,0,0,1,.02-.489,4.082,4.082,0,0,1,.457-1.257,4.434,4.434,0,0,1,7.52-.355,4.082,4.082,0,0,1,.573,1.209,1.028,1.028,0,0,1,.066.486",
    transform: "translate(-177.227 -122.987)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138487",
    "data-name": "Path 138487",
    d: "M631.979,404.882l.717-12.142-10.007-1.226-.142,13.114,4.662,2.147Z",
    transform: "translate(-184.331 -115.924)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138488",
    "data-name": "Path 138488",
    d: "M627.724,410.38l4.012.018s5.86,5.344,6.292,8.11a6.126,6.126,0,0,1-.123,2.093l-9.361-.279c-1.882-.111-6.818-.395-6.818-.395l.577-9.784Z",
    transform: "translate(-184.089 -121.44)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138489",
    "data-name": "Path 138489",
    d: "M637.214,352.669c-.033.567-5.357,35.478-5.357,35.478l-12.144-.156.862-36.3Z",
    transform: "translate(-183.493 -104.132)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18633",
    "data-name": "Rectangle 18633",
    width: 1.699,
    height: 16.276,
    transform: "matrix(0.059, -0.998, 0.998, 0.059, 437.637, 298.861)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138490",
    "data-name": "Path 138490",
    d: "M634.757,411.519a18.238,18.238,0,0,1,.79,7.664c-.107,0-.129-1.727-.351-3.837s-.544-3.8-.44-3.827",
    transform: "translate(-187.941 -121.848)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138491",
    "data-name": "Path 138491",
    d: "M622.891,419.528a1.022,1.022,0,0,1,.094-.481,4.09,4.09,0,0,1,.644-1.173,4.431,4.431,0,0,1,7.485.8,4.055,4.055,0,0,1,.382,1.282,1.032,1.032,0,0,1-.008.49,8.516,8.516,0,0,0-.6-1.652,4.533,4.533,0,0,0-1.226-1.406,4.343,4.343,0,0,0-4.335-.462,4.535,4.535,0,0,0-1.494,1.116,8.486,8.486,0,0,0-.938,1.488",
    transform: "translate(-184.431 -123.228)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138492",
    "data-name": "Path 138492",
    d: "M577.209,204.443a13.069,13.069,0,0,0,2.914-4.219c.685-2.074,2.024-5.088,2.155-5.735s-.541-.949-1.332-.324a6.508,6.508,0,0,0-1.561,2.856c-.4,1.057-.993.933-.993.933s1.063-4.957,1.309-6.532c.263-1.687.617-3-.153-3.272-.862-.3-1.108.5-1.421,1.709-.3,1.168-1.079,4.016-1.079,4.016l.531-4.522s.505-2.426-.542-2.438-1.064,2.471-1.064,2.471l-.864,4.538s.726-5.714.309-5.928-1.064-.346-1.33,1.446-1.081,5.451-1.081,5.451l-.153-.018.363-3.857a1.481,1.481,0,0,0-.04-.738c-.206-.352-.667-.587-.963.543-.341,1.3-1,5.737-1.19,7.316a47.667,47.667,0,0,0,.084,5.588l-2.469,3.692,6.139,3.348Z",
    transform: "translate(-168.37 -55.344)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18634",
    "data-name": "Rectangle 18634",
    width: 13.675,
    height: 11.866,
    transform: "translate(425.103 167.565)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138493",
    "data-name": "Path 138493",
    d: "M581.378,239.521l-6.017-.858-9.482-4.567,7.055-17.936-8.8-4.361s-7.47,16.409-8.77,21.117-1.62,7.051,1.417,9.523,25.183,13.105,25.183,13.105Z",
    transform: "translate(-164.161 -62.712)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138494",
    "data-name": "Path 138494",
    d: "M620.083,249.8l-4.574-1.333-12.87-.51a22.61,22.61,0,0,0-6.144.849c-3.292.762-7.619,1.508-7.619,1.508s-.925,10.862-.925,13.076l3.853,18.563h31.654l1.931-13.384c-.007.04,1.915-14.824,1.9-14.862a24.981,24.981,0,0,0-7.207-3.907",
    transform: "translate(-174.088 -73.416)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138495",
    "data-name": "Path 138495",
    d: "M568.946,243.562a7.582,7.582,0,0,0-4.556,3.555,2.213,2.213,0,0,1,.352-.815,5.9,5.9,0,0,1,3.328-2.6,2.2,2.2,0,0,1,.876-.144",
    transform: "translate(-167.111 -72.114)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138496",
    "data-name": "Path 138496",
    d: "M642.329,256.131a11.782,11.782,0,0,1,4.2,7.753c.716,5.279,2.237,20.493,2.237,20.493h-8.411l-1.61-6.33Z",
    transform: "translate(-189.128 -75.839)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138497",
    "data-name": "Path 138497",
    d: "M641.8,264.85a.778.778,0,0,1-.006.226c-.017.175-.037.386-.063.641-.059.557-.159,1.36-.3,2.352-.269,1.982-.7,4.713-1.2,7.724-.491,2.994-.936,5.7-1.266,7.711-.153.959-.278,1.748-.372,2.339-.043.252-.078.462-.108.635a.8.8,0,0,1-.054.22.783.783,0,0,1,.006-.226c.017-.175.037-.386.063-.641.059-.557.159-1.36.3-2.352.269-1.983.7-4.714,1.2-7.725.491-2.993.936-5.7,1.266-7.71.153-.959.278-1.748.372-2.339.044-.253.079-.462.108-.635a.8.8,0,0,1,.054-.22",
    transform: "translate(-189.038 -78.42)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138498",
    "data-name": "Path 138498",
    d: "M585.921,256.812a22.547,22.547,0,0,1,.512,2.538c.29,1.571.726,3.734,1.208,6.126s.878,4.57,1.1,6.157c.114.793.193,1.436.232,1.883a2.55,2.55,0,0,1,.025.7,22.964,22.964,0,0,1-.512-2.538c-.29-1.571-.727-3.734-1.208-6.128s-.878-4.569-1.1-6.155c-.114-.793-.193-1.437-.232-1.884a2.554,2.554,0,0,1-.025-.7",
    transform: "translate(-173.483 -76.04)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138499",
    "data-name": "Path 138499",
    d: "M586.819,332.8a9.388,9.388,0,0,1-9.407-9.092c-.26-9.522-.267-24.269-.256-30.664A3.14,3.14,0,0,1,580.3,289.9h48.924a3.14,3.14,0,0,1,3.143,3.215c-.16,6.638-.535,22.035-.767,31.579a8.3,8.3,0,0,1-8.3,8.1Z",
    transform: "translate(-170.891 -85.839)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138500",
    "data-name": "Path 138500",
    d: "M573.906,402.918l-2.8-.341,5.76-47.125a5.468,5.468,0,0,1,5.386-4.851h41.256a5.47,5.47,0,0,1,5.383,4.832c1.38,11.14,5.223,46.8,5.261,47.163l-2.8.3c-.04-.359-3.879-36-5.256-47.118a2.652,2.652,0,0,0-2.59-2.363H582.257a2.65,2.65,0,0,0-2.59,2.374Z",
    transform: "translate(-169.102 -103.811)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138501",
    "data-name": "Path 138501",
    d: "M573.89,402.845s.023-.257.077-.743.141-1.214.25-2.156l.98-8.269c.86-7.173,2.1-17.551,3.648-30.412q.29-2.409.6-4.934a5.6,5.6,0,0,1,.235-1.285,2.876,2.876,0,0,1,.744-1.122,2.74,2.74,0,0,1,1.2-.642,5.942,5.942,0,0,1,1.349-.077l11.054-.011,24.441-.018h4.894a2.754,2.754,0,0,1,1.656.472,2.846,2.846,0,0,1,1.072,1.367,7.65,7.65,0,0,1,.281,1.683q.186,1.665.375,3.349.754,6.736,1.539,13.756c1.045,9.351,2.128,19.05,3.24,29l-.2-.163,2.8-.3-.163.2c-.143-1.285-.3-2.674-.453-4.067-1.02-9.154-2.019-18.116-2.988-26.816q-.726-6.525-1.43-12.845-.175-1.58-.349-3.144a5.469,5.469,0,0,0-1.042-2.819,5.312,5.312,0,0,0-2.351-1.806,5.393,5.393,0,0,0-1.449-.327c-.487-.035-1.014-.013-1.52-.02l-23.4-.013-10.815-.008-5.164,0c-.424,0-.847,0-1.25.022a5.354,5.354,0,0,0-1.188.26,5.173,5.173,0,0,0-2.024,1.265,5.271,5.271,0,0,0-1.258,1.982,10.189,10.189,0,0,0-.427,2.307q-.289,2.344-.567,4.6-.556,4.5-1.064,8.612c-.679,5.476-1.29,10.411-1.827,14.737-1.084,8.635-1.862,14.831-2.267,18.052l-.03-.037,2.1.276c.46.063.689.1.689.1s-.214-.018-.673-.068l-2.126-.239-.034,0,0-.034c.384-3.224,1.121-9.425,2.149-18.067l1.777-14.743q.5-4.108,1.041-8.615.272-2.251.557-4.6a10.422,10.422,0,0,1,.436-2.369,5.546,5.546,0,0,1,1.318-2.087,5.466,5.466,0,0,1,2.131-1.337,5.688,5.688,0,0,1,1.254-.277c.434-.03.855-.027,1.277-.026l5.164,0,10.815-.008,23.4-.014c.515.007,1.01-.017,1.546.02a5.539,5.539,0,0,1,4.055,2.27,5.824,5.824,0,0,1,1.109,2.982q.175,1.565.352,3.144.706,6.315,1.436,12.846c.972,8.7,1.972,17.664,3,26.819.155,1.393.31,2.782.453,4.067l.02.182-.183.02-2.8.3-.182.02-.02-.182c-1.109-9.953-2.188-19.65-3.23-29q-.78-7.013-1.53-13.755-.187-1.684-.372-3.35a7.449,7.449,0,0,0-.26-1.6,2.507,2.507,0,0,0-.943-1.206,2.4,2.4,0,0,0-1.465-.415h-1.641l-3.253,0-24.441-.017-11.054-.011a5.712,5.712,0,0,0-1.285.067,2.467,2.467,0,0,0-1.082.575,2.606,2.606,0,0,0-.676,1.014,5.4,5.4,0,0,0-.224,1.227q-.313,2.533-.612,4.951c-1.6,12.877-2.9,23.27-3.792,30.452L574.265,400l-.274,2.129c-.063.478-.1.715-.1.715",
    transform: "translate(-169.086 -103.738)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138502",
    "data-name": "Path 138502",
    d: "M627.692,325.248a.894.894,0,0,1,.02.211,1.782,1.782,0,0,1-.033.622A3.046,3.046,0,0,1,626.3,328c-1.726,1.228-4.716,1.986-8.379,2.459-7.366.911-17.643.794-28.89-.266a10.224,10.224,0,0,1-4.078-1.105,5.493,5.493,0,0,1-2.46-3.269,19.121,19.121,0,0,1-.652-3.893q-.177-1.913-.346-3.743c-.418-4.876-.663-9.277-.8-12.976s-.168-6.693-.169-8.762c0-1.034.008-1.838.02-2.382.007-.256.013-.46.017-.619a.949.949,0,0,1,.018-.211.927.927,0,0,1,.02.211c0,.16.011.364.019.619.012.57.028,1.367.049,2.381.044,2.068.113,5.06.285,8.753s.439,8.088.875,12.958q.174,1.825.358,3.736a18.914,18.914,0,0,0,.645,3.82,5.135,5.135,0,0,0,2.3,3.062,9.91,9.91,0,0,0,3.934,1.056c11.217,1.058,21.481,1.215,28.818.374,3.65-.436,6.622-1.156,8.329-2.319a3.009,3.009,0,0,0,1.385-1.817,1.944,1.944,0,0,0,.068-.6.969.969,0,0,1,.018-.212",
    transform: "translate(-171.891 -86.823)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138503",
    "data-name": "Path 138503",
    d: "M610.132,201.436c1.666-1.428,5.251-.733,5.976.434a2.78,2.78,0,0,1,3.46,1.652l3.74,1.323a4.029,4.029,0,0,1,1.753.976,1.388,1.388,0,0,1,.1,1.837,2.106,2.106,0,0,1,.463,3.453,1.469,1.469,0,0,1-.481,2.082,14.709,14.709,0,0,1,1.942,4.594,2.994,2.994,0,0,1-.061,2.05,1.2,1.2,0,0,1-1.746.485,1.72,1.72,0,0,1-.15,1.852c.648.1.717,1.128.211,1.544a2.392,2.392,0,0,1-1.888.279,3.155,3.155,0,0,0-1.93.087.6.6,0,0,0,.16.439,2.7,2.7,0,0,1,.141,3.719c-.091.1-.176.19-.251.272a5.9,5.9,0,0,1-2.057,1.091c-1.567.583-2.425.329-4.1.36.315,1.115-2.645,3.128-5.41.44-11.132,4.927-13.153-.677-13.153-.677-3.061,2.014-5.888.484-6.187-.372a2.252,2.252,0,0,1-1.972-.931,6.635,6.635,0,0,1-.969-2.053,3.952,3.952,0,0,1-2.38-3.886,4.885,4.885,0,0,1-1.4-3.675,2.865,2.865,0,0,1-1.15-4.043,17.3,17.3,0,0,1,2.536-5.076,1.885,1.885,0,0,1-.673-2.705,5.454,5.454,0,0,1,2.523-1.873c-.8.109-1.348-.944-1.067-1.7a3.07,3.07,0,0,1,1.782-1.527,14.63,14.63,0,0,1,3.375-1.026,6.984,6.984,0,0,1,3.813-3.084c5.432-1.785,9.1-1.949,15.04,3.656",
    transform: "translate(-172.438 -58.234)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138504",
    "data-name": "Path 138504",
    d: "M637.206,221.765a1.342,1.342,0,0,0,.288.01,1.972,1.972,0,0,0,.8-.223,1.925,1.925,0,0,0,.9-.954,2.028,2.028,0,0,0-.066-1.73,5.132,5.132,0,0,0-.617-.831,2.433,2.433,0,0,1-.556-.94,1.591,1.591,0,0,1,.208-1.13c.188-.365.448-.712.636-1.12a3.543,3.543,0,0,0-2.047-4.825l.021.088a1.8,1.8,0,0,0,.415-.741,2.275,2.275,0,0,0,.061-.859,2.484,2.484,0,0,0-.254-.836,2.971,2.971,0,0,0-.523-.711,5.587,5.587,0,0,0-2.229-1.267,8.461,8.461,0,0,0-2.394-.427l.051.058a2.567,2.567,0,0,0-1.144-2.395,2.614,2.614,0,0,0-1.225-.411,4.206,4.206,0,0,0-1.216.153,2.393,2.393,0,0,1-.569.054,1.474,1.474,0,0,1-.531-.129,4.436,4.436,0,0,1-.886-.588,3.886,3.886,0,0,0-.85-.535,3.141,3.141,0,0,0-.889-.242,3.034,3.034,0,0,0-1.541.206,3.132,3.132,0,0,0-.973.639,3.015,3.015,0,0,0-.459.566,1.62,1.62,0,0,0-.12.221s.044-.075.136-.211a3.2,3.2,0,0,1,.468-.55,3.135,3.135,0,0,1,.968-.617,3,3,0,0,1,1.513-.188,3.093,3.093,0,0,1,.867.243,3.807,3.807,0,0,1,.83.531,4.519,4.519,0,0,0,.9.6,1.559,1.559,0,0,0,.562.139,2.456,2.456,0,0,0,.591-.053,4.159,4.159,0,0,1,1.193-.147,2.526,2.526,0,0,1,1.178.4,2.467,2.467,0,0,1,1.092,2.3l-.006.056.056,0a8.384,8.384,0,0,1,2.363.424,5.5,5.5,0,0,1,2.184,1.242,2.831,2.831,0,0,1,.5.683,2.4,2.4,0,0,1,.244.8,2.169,2.169,0,0,1-.057.817,1.689,1.689,0,0,1-.389.7l-.057.061.078.027a3.445,3.445,0,0,1,2,4.684c-.18.4-.438.743-.629,1.118a1.676,1.676,0,0,0-.21,1.191,2.52,2.52,0,0,0,.579.971,5.089,5.089,0,0,1,.615.814,1.976,1.976,0,0,1,.077,1.675,1.894,1.894,0,0,1-.862.942,2.024,2.024,0,0,1-.781.237c-.187.015-.286,0-.286.01",
    transform: "translate(-184.018 -59.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138505",
    "data-name": "Path 138505",
    d: "M591.048,204.311a.3.3,0,0,0,.019-.067c.012-.051.027-.116.046-.2l.174-.764c.08-.331.182-.734.335-1.191a6.983,6.983,0,0,1,.68-1.482,4.625,4.625,0,0,1,1.35-1.417,3.418,3.418,0,0,1,.994-.443,9.812,9.812,0,0,1,1.156-.172,3.274,3.274,0,0,0,1.2-.35,5.175,5.175,0,0,0,1.034-.786c.322-.3.633-.617.985-.9a3.682,3.682,0,0,1,1.18-.65,6.526,6.526,0,0,1,2.661-.206,17.011,17.011,0,0,1,2.476.434,12.875,12.875,0,0,1,3.9,1.67,9.144,9.144,0,0,1,2.123,1.915c.1.135.2.251.276.358l.184.275.115.168a.337.337,0,0,0,.042.055.3.3,0,0,0-.032-.061l-.106-.174-.175-.282c-.073-.109-.168-.227-.269-.365a8.89,8.89,0,0,0-2.114-1.954,12.781,12.781,0,0,0-3.916-1.7,16.9,16.9,0,0,0-2.492-.443,6.591,6.591,0,0,0-2.705.208,3.771,3.771,0,0,0-1.214.669c-.358.284-.67.605-.99.9a5.109,5.109,0,0,1-1.011.773,3.18,3.18,0,0,1-1.159.341,9.881,9.881,0,0,0-1.167.179,3.492,3.492,0,0,0-1.02.461,4.683,4.683,0,0,0-1.366,1.451,6.945,6.945,0,0,0-.672,1.5c-.149.462-.245.869-.318,1.2s-.123.593-.155.769c-.015.083-.026.149-.035.2a.285.285,0,0,0-.008.069",
    transform: "translate(-175.005 -57.896)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138506",
    "data-name": "Path 138506",
    d: "M594.608,226.485a1.206,1.206,0,0,1-.341-.148,2.688,2.688,0,0,1-.783-.729,3.264,3.264,0,0,1-.587-1.6,2.911,2.911,0,0,1,.641-2.165l.042.2a3.071,3.071,0,0,1,.139-5.643l-.075.259a4.214,4.214,0,0,1-.685-3.367,4.181,4.181,0,0,1,4.14-3.2l-.184.22a4.331,4.331,0,0,1,6.27-4.728l-.207.077a4.3,4.3,0,0,1,2.33-2.33,4.069,4.069,0,0,1,2.518-.182,4.008,4.008,0,0,1,1.463.678,2.84,2.84,0,0,1,.321.275c.067.068.1.106.094.111a4.951,4.951,0,0,0-1.915-.9,3.945,3.945,0,0,0-2.387.238,4.069,4.069,0,0,0-2.148,2.218l-.06.153-.147-.077a4.142,4.142,0,0,0-4.041.2,4.09,4.09,0,0,0-1.734,4.192l.047.225-.231,0a3.765,3.765,0,0,0-1.646.344,3.725,3.725,0,0,0-2.133,2.57,3.882,3.882,0,0,0,.609,3.089l.129.177-.2.082a2.827,2.827,0,0,0-1.745,2.733,2.877,2.877,0,0,0,1.587,2.363l.153.072-.111.127A2.719,2.719,0,0,0,593.1,224a3.2,3.2,0,0,0,.5,1.533,3.373,3.373,0,0,0,1.009.956",
    transform: "translate(-175.224 -60.116)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138507",
    "data-name": "Path 138507",
    d: "M610.551,228.049a1.786,1.786,0,0,1-.455-.435,4.736,4.736,0,0,1-.857-1.543,4.868,4.868,0,0,1-.117-2.7,5.087,5.087,0,0,1,1.915-2.871l-.042.234a5.764,5.764,0,0,1,3.527-8.85l-.114.222a4.881,4.881,0,0,1-.23-2.978,4.682,4.682,0,0,1,1.082-2.046,4.489,4.489,0,0,1,1.166-.93,1.468,1.468,0,0,1,.487-.2,6.623,6.623,0,0,0-1.507,1.26,4.612,4.612,0,0,0-.7,4.77l.077.179-.191.043a5.472,5.472,0,0,0-3.315,8.342l.092.137-.134.1a4.856,4.856,0,0,0-1.836,2.664,4.772,4.772,0,0,0,.038,2.571,6.37,6.37,0,0,0,1.112,2.041",
    transform: "translate(-180.316 -60.978)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138508",
    "data-name": "Path 138508",
    d: "M629.7,227.471a3.229,3.229,0,0,0,.9-1.205,2.386,2.386,0,0,0,.043-1.674,2.482,2.482,0,0,0-1.5-1.509l-.2-.07.137-.169A5.79,5.79,0,0,0,630.3,219.8a5.511,5.511,0,0,0-.86-3.605,5.821,5.821,0,0,0-3.23-2.413l-.18-.051.064-.175a5.232,5.232,0,0,0,.058-3.351,5.156,5.156,0,0,0-1.454-2.238,6.965,6.965,0,0,0-2.087-1.218,1.913,1.913,0,0,1,.638.148,5.088,5.088,0,0,1,1.59.909,5.235,5.235,0,0,1,1.591,2.307,5.459,5.459,0,0,1-.011,3.562l-.116-.226a6.1,6.1,0,0,1,3.445,2.547,5.8,5.8,0,0,1,.9,3.842,6.021,6.021,0,0,1-1.347,3.2l-.067-.239a2.722,2.722,0,0,1,1.639,1.717,2.533,2.533,0,0,1-.115,1.819,2.5,2.5,0,0,1-.706.928.945.945,0,0,1-.352.21",
    transform: "translate(-184.35 -61.215)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44502",
    "data-name": "Group 44502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44501",
    "data-name": "Group 44501",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138509",
    "data-name": "Path 138509",
    d: "M495.036,229.563,480.2,231.019l-.056-12.63s-1.061-.1-1.731-5.521-1.95-14.617-1.95-14.617a20.241,20.241,0,0,1,19.9.21l.9.527Z",
    transform: "translate(-141.079 -57.957)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138510",
    "data-name": "Path 138510",
    d: "M504.568,209.977c.091-.051,3.741-1.531,4.029,2.194s-3.644,3.265-3.66,3.159-.37-5.353-.37-5.353",
    transform: "translate(-149.399 -62.074)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138511",
    "data-name": "Path 138511",
    d: "M477.472,211.838c-.1-.03-3.626-.542-3.092,3.156s4.27,2.389,4.261,2.282-1.169-5.438-1.169-5.438",
    transform: "translate(-140.444 -62.712)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138512",
    "data-name": "Path 138512",
    d: "M497.133,204.965c-.23,3.173.064,4.8-.237,6.931a11.044,11.044,0,0,1-4.775,8.069c-2.886,1.981-7.038,2.411-9.919.467a8.682,8.682,0,0,1-4.019-5.262c-.53-2.305-1.259-6.41-1.537-8.758-.5-4.234-1.242-8.253-1.242-8.253l12.3-3.579,7.589,3.307Z",
    transform: "translate(-140.763 -57.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138513",
    "data-name": "Path 138513",
    d: "M490.436,233.9a5.822,5.822,0,0,0,4.249-.933c-.046-.089-.943.294-2.107.545s-2.138.289-2.142.389",
    transform: "translate(-145.215 -68.977)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138514",
    "data-name": "Path 138514",
    d: "M496.377,208.189c.015-3.228-.151-6.9-.006-10.316a20.955,20.955,0,0,0,.061-4.409,10.277,10.277,0,0,0-1.238-3.641,5.527,5.527,0,0,0-4.125-2.419,5.7,5.7,0,0,0-4.518,1.713,4.275,4.275,0,0,0-4.486-1.171,4.116,4.116,0,0,0-2.752,3.65,3.011,3.011,0,0,0-3.456.023,2.783,2.783,0,0,0-.906,3.229,2.818,2.818,0,0,0-1.9,1.785,2.652,2.652,0,0,0,.491,2.5c.676.8,1.777,1.159,2.508,1.912a3.026,3.026,0,0,1,.564,3.329",
    transform: "translate(-140.029 -55.484)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138515",
    "data-name": "Path 138515",
    d: "M479.7,202.035a.815.815,0,0,0,.177.333,2.5,2.5,0,0,0,.817.71,2.7,2.7,0,0,0,1.686.318,2.852,2.852,0,0,0,1.909-1.132l-.272-.04a2.565,2.565,0,0,0,1.883,1.671,3.1,3.1,0,0,0,2.789-.656,4.148,4.148,0,0,0,1.368-2.188l-.3.067a3.587,3.587,0,0,0,3.006,1.188,3.343,3.343,0,0,0,2.285-1.206,3.2,3.2,0,0,0,.707-1.516,1.335,1.335,0,0,0,.008-.6c-.027,0-.03.21-.123.574a3.374,3.374,0,0,1-.76,1.4,3.162,3.162,0,0,1-2.138,1.056,3.309,3.309,0,0,1-2.717-1.113l-.216-.257-.084.324a3.866,3.866,0,0,1-1.262,2,2.763,2.763,0,0,1-2.473.6,2.277,2.277,0,0,1-1.678-1.437l-.091-.3-.182.261a2.615,2.615,0,0,1-1.694,1.057,2.576,2.576,0,0,1-1.563-.232,3.54,3.54,0,0,1-1.08-.891",
    transform: "translate(-142.034 -58.919)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138516",
    "data-name": "Path 138516",
    d: "M479.462,198.653a3.3,3.3,0,0,1,.386-1.411,2.3,2.3,0,0,1,1.223-1,2.468,2.468,0,0,1,1.951.141l.328.177-.072-.359a2.732,2.732,0,0,1,.011-1.081,2.964,2.964,0,0,1,1.351-1.9,3.06,3.06,0,0,1,1.936-.382,4.176,4.176,0,0,1,1.728.707c.014-.012-.091-.168-.358-.378a3.089,3.089,0,0,0-1.33-.567,3.142,3.142,0,0,0-3.673,2.457,2.972,2.972,0,0,0,0,1.218l.256-.182a2.743,2.743,0,0,0-2.229-.123,2.459,2.459,0,0,0-1.318,1.174,2.284,2.284,0,0,0-.265,1.111c.01.267.062.405.08.4",
    transform: "translate(-141.942 -57.011)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138517",
    "data-name": "Path 138517",
    d: "M490.731,198.854c.046-.026-.034-.21-.046-.511a2.388,2.388,0,0,1,.271-1.14,11.7,11.7,0,0,1,.616-1.064.382.382,0,0,1,.392-.12c.019-.009.011-.085-.1-.14a.446.446,0,0,0-.467.089,2.773,2.773,0,0,0-.386.471,4.383,4.383,0,0,0-.374.622,1.991,1.991,0,0,0-.2,1.317c.086.345.258.5.294.476",
    transform: "translate(-145.203 -57.988)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138518",
    "data-name": "Path 138518",
    d: "M499.14,191.765c.037-.018-.031-.289-.31-.651a1.827,1.827,0,0,0-.636-.518,1.547,1.547,0,0,0-1.043-.1,2.462,2.462,0,0,0-1.42,1.09c-.243.374-.344.624-.307.648s.223-.182.506-.5a2.68,2.68,0,0,1,1.3-.9,1.5,1.5,0,0,1,1.408.451c.3.289.45.517.5.491",
    transform: "translate(-146.689 -56.39)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138519",
    "data-name": "Path 138519",
    d: "M500.4,212.793a6.022,6.022,0,0,0,1.063-2.514,5.868,5.868,0,0,0,.17-2.7c-.1,0-.171,1.2-.515,2.631s-.813,2.546-.719,2.588",
    transform: "translate(-148.162 -61.461)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138520",
    "data-name": "Path 138520",
    d: "M498.148,214.961a4.482,4.482,0,0,0,.743-1.789,4.4,4.4,0,0,0,.251-1.91,18.584,18.584,0,0,0-.995,3.7",
    transform: "translate(-147.492 -62.553)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138521",
    "data-name": "Path 138521",
    d: "M483.174,218.537a5.71,5.71,0,0,0,.794,3.214,5.917,5.917,0,0,0,2.212,2.512,20.5,20.5,0,0,1-1.9-2.668,20.044,20.044,0,0,1-1.109-3.058",
    transform: "translate(-143.053 -64.707)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138522",
    "data-name": "Path 138522",
    d: "M480.29,214.956a4.6,4.6,0,0,0,.08,2.966,4.706,4.706,0,0,0,1.6,2.523,9.634,9.634,0,0,1-1.677-5.488",
    transform: "translate(-142.154 -63.647)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138523",
    "data-name": "Path 138523",
    d: "M471.489,400.056l-5.864-13.007,9.782-4.043,4.914,13.725-3.7,3.553Z",
    transform: "translate(-137.868 -113.406)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138524",
    "data-name": "Path 138524",
    d: "M476.337,404.5l-3.787,1.328s-3.791,6.966-3.3,9.722a6.129,6.129,0,0,0,.8,1.938l8.755-3.325c1.742-.719,6.315-2.6,6.315-2.6l-3.743-9.058Z",
    transform: "translate(-138.93 -119.179)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18636",
    "data-name": "Rectangle 18636",
    width: 16.276,
    height: 1.699,
    transform: "matrix(0.924, -0.382, 0.382, 0.924, 330.505, 297.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138525",
    "data-name": "Path 138525",
    d: "M475.389,407.8c.106-.011.347,1.7.835,3.761s1.023,3.7.923,3.741a18.227,18.227,0,0,1-1.758-7.5",
    transform: "translate(-140.749 -120.746)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138526",
    "data-name": "Path 138526",
    d: "M486.3,411.963a8.514,8.514,0,0,0-1.373-1.1,4.52,4.52,0,0,0-1.777-.567,4.341,4.341,0,0,0-3.946,1.853,4.524,4.524,0,0,0-.7,1.729,8.5,8.5,0,0,0-.031,1.758c-.02.006-.1-.151-.168-.46a4.084,4.084,0,0,1-.058-1.337,4.433,4.433,0,0,1,6.814-3.2,4.052,4.052,0,0,1,.992.9c.192.251.263.412.246.423",
    transform: "translate(-141.598 -121.377)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138527",
    "data-name": "Path 138527",
    d: "M449.789,324.464s-6.266,4.758-6.849,9.033a25.1,25.1,0,0,0,1,9.785c.677,1.825,12.683,31.094,12.683,31.094l13.765-6.031-9.375-27.563Z",
    transform: "translate(-131.107 -96.072)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138528",
    "data-name": "Path 138528",
    d: "M515.247,400.248,520,386.794l-10.088-3.206-3.742,14.09,3.99,3.228Z",
    transform: "translate(-149.872 -113.578)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138529",
    "data-name": "Path 138529",
    d: "M510.115,405.17,514,406.175s4.364,6.622,4.1,9.41a6.145,6.145,0,0,1-.634,2l-9-2.576c-1.8-.57-6.511-2.06-6.511-2.06l2.968-9.341Z",
    transform: "translate(-148.624 -119.505)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18637",
    "data-name": "Rectangle 18637",
    width: 1.7,
    height: 16.276,
    transform: "translate(353.327 293.442) rotate(-72.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138530",
    "data-name": "Path 138530",
    d: "M517.194,407.947a18.224,18.224,0,0,1-1.121,7.623c-.1-.029.3-1.706.605-3.8s.408-3.82.515-3.818",
    transform: "translate(-152.801 -120.79)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138531",
    "data-name": "Path 138531",
    d: "M503.847,413.165c-.018-.011.039-.177.21-.443a4.09,4.09,0,0,1,.912-.978,4.432,4.432,0,0,1,7.059,2.615,4.05,4.05,0,0,1,.055,1.337c-.044.313-.108.477-.129.472a8.525,8.525,0,0,0-.178-1.749,4.536,4.536,0,0,0-.842-1.665,4.347,4.347,0,0,0-4.089-1.515,4.537,4.537,0,0,0-1.723.714,8.489,8.489,0,0,0-1.275,1.211",
    transform: "translate(-149.184 -121.64)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138532",
    "data-name": "Path 138532",
    d: "M507.242,367.255l8.3-30.9,7.674-14.376s7.908,4.718,9.208,9.921c.763,3.052-6.12,25.068-6.12,25.068l-4.759,14.9Z",
    transform: "translate(-150.191 -95.336)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138533",
    "data-name": "Path 138533",
    d: "M504.988,246.871a43.6,43.6,0,0,0-17.1-9.523H472.1l-12.482,6.308s-7.13,3.41-7.13,13.809.512,25.231,1.7,27.788a12.537,12.537,0,0,0,2.49,3.688c-.41,6.282-.724,11.051-.816,12.337l48.234,1.085,3.753-47.42a11.344,11.344,0,0,0-2.868-8.071",
    transform: "translate(-133.979 -70.277)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138534",
    "data-name": "Path 138534",
    d: "M462.9,280.985c-.1.01-.589-4.176-1.091-9.348s-.827-9.374-.726-9.384.589,4.175,1.091,9.349.827,9.373.726,9.383",
    transform: "translate(-136.518 -77.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138535",
    "data-name": "Path 138535",
    d: "M520.447,281.477c-.1-.007.115-4.425.484-9.869s.748-9.851.849-9.845-.115,4.425-.484,9.869-.748,9.851-.849,9.844",
    transform: "translate(-154.093 -77.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138536",
    "data-name": "Path 138536",
    d: "M462.494,331.987a9.47,9.47,0,0,1-9.489-9.173c-.263-9.6-.27-24.482-.258-30.933a3.167,3.167,0,0,1,3.17-3.162h49.354a3.167,3.167,0,0,1,3.17,3.243c-.162,6.7-.54,22.229-.774,31.856a8.373,8.373,0,0,1-8.376,8.169Z",
    transform: "translate(-134.054 -85.488)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138537",
    "data-name": "Path 138537",
    d: "M449.468,402.725l-2.82-.344,5.811-47.538a5.516,5.516,0,0,1,5.434-4.894h41.618a5.519,5.519,0,0,1,5.431,4.875c1.392,11.238,5.268,47.215,5.307,47.577l-2.823.3c-.039-.363-3.913-36.317-5.3-47.532a2.675,2.675,0,0,0-2.612-2.384H457.893a2.675,2.675,0,0,0-2.614,2.4Z",
    transform: "translate(-132.249 -103.617)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138538",
    "data-name": "Path 138538",
    d: "M449.452,402.652s.023-.259.079-.75.141-1.223.252-2.174c.227-1.913.56-4.721.989-8.341.868-7.236,2.124-17.706,3.68-30.679q.293-2.431.6-4.977a5.612,5.612,0,0,1,.237-1.3,2.9,2.9,0,0,1,.75-1.131,2.758,2.758,0,0,1,1.211-.648,6,6,0,0,1,1.36-.078l11.151-.011,24.656-.017,3.281,0h1.656a2.783,2.783,0,0,1,1.67.476,2.873,2.873,0,0,1,1.08,1.379,7.654,7.654,0,0,1,.283,1.7q.189,1.68.379,3.379.76,6.8,1.553,13.876c1.054,9.434,2.147,19.217,3.269,29.258l-.2-.162,2.823-.3-.163.2c-.144-1.3-.3-2.7-.458-4.1-1.029-9.235-2.036-18.276-3.015-27.052q-.732-6.583-1.442-12.958-.177-1.592-.353-3.171a5.511,5.511,0,0,0-1.051-2.844,5.237,5.237,0,0,0-3.835-2.152c-.491-.036-1.023-.013-1.533-.02l-23.6-.013-10.911-.008-5.209,0c-.428,0-.855,0-1.261.022a5.447,5.447,0,0,0-1.2.263,5.219,5.219,0,0,0-2.043,1.276,5.328,5.328,0,0,0-1.27,2,10.308,10.308,0,0,0-.43,2.329q-.291,2.364-.572,4.635l-1.073,8.688c-.684,5.524-1.3,10.5-1.843,14.867-1.093,8.711-1.877,14.962-2.286,18.211l-.03-.038,2.12.279c.465.063.7.1.7.1s-.216-.018-.679-.068l-2.144-.242-.034,0,0-.034c.387-3.251,1.131-9.508,2.168-18.225.527-4.366,1.127-9.346,1.793-14.873q.5-4.145,1.051-8.691.275-2.27.561-4.636a10.517,10.517,0,0,1,.439-2.389,5.606,5.606,0,0,1,1.33-2.105,5.519,5.519,0,0,1,2.149-1.349,5.746,5.746,0,0,1,1.265-.279c.438-.03.862-.027,1.288-.025l5.209,0,10.911-.008,23.6-.013c.519.007,1.019-.018,1.56.02a5.578,5.578,0,0,1,4.089,2.289,5.863,5.863,0,0,1,1.118,3.008q.177,1.579.355,3.172.712,6.371,1.449,12.959c.98,8.777,1.99,17.819,3.021,27.054.156,1.406.313,2.806.457,4.1l.02.182-.182.02-2.824.3-.181.02-.02-.182c-1.119-10.04-2.208-19.822-3.258-29.255q-.787-7.075-1.543-13.876-.189-1.7-.375-3.379a7.546,7.546,0,0,0-.263-1.62,2.536,2.536,0,0,0-.952-1.217,2.436,2.436,0,0,0-1.48-.42H494.42l-24.656-.018-11.151-.011a5.812,5.812,0,0,0-1.3.068,2.49,2.49,0,0,0-1.092.581,2.631,2.631,0,0,0-.681,1.023,5.417,5.417,0,0,0-.226,1.238q-.316,2.554-.617,4.995c-1.617,12.991-2.923,23.474-3.824,30.719-.454,3.6-.806,6.4-1.046,8.3-.12.939-.213,1.657-.276,2.148s-.1.722-.1.722",
    transform: "translate(-132.234 -103.545)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138539",
    "data-name": "Path 138539",
    d: "M503.726,324.372a.908.908,0,0,1,.02.212,1.8,1.8,0,0,1-.034.627,3.071,3.071,0,0,1-1.387,1.934c-1.741,1.238-4.756,2-8.452,2.481-7.431.918-17.8.8-29.143-.27a10.3,10.3,0,0,1-4.113-1.115,5.54,5.54,0,0,1-2.481-3.3,19.312,19.312,0,0,1-.657-3.927q-.178-1.93-.349-3.776c-.422-4.919-.669-9.359-.8-13.09s-.17-6.752-.172-8.839c0-1.044.008-1.854.02-2.4.007-.258.013-.464.017-.625a.915.915,0,0,1,.018-.213.937.937,0,0,1,.019.213c0,.161.011.367.02.624.011.575.028,1.379.049,2.4.045,2.086.115,5.1.288,8.83s.442,8.159.882,13.071q.176,1.841.361,3.77a19.011,19.011,0,0,0,.652,3.853,5.179,5.179,0,0,0,2.322,3.09,10.01,10.01,0,0,0,3.969,1.066c11.316,1.066,21.67,1.225,29.072.376,3.682-.44,6.679-1.166,8.4-2.339a3.036,3.036,0,0,0,1.4-1.834,1.94,1.94,0,0,0,.069-.61.983.983,0,0,1,.018-.214",
    transform: "translate(-135.063 -86.481)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44507",
    "data-name": "Group 44507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44506",
    "data-name": "Group 44506",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138540",
    "data-name": "Path 138540",
    d: "M353.589,321.864l.208,11.8s-11.924,4.175-12.1,6.359l22.895.417.429-18.4Z",
    transform: "translate(-101.175 -95.302)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138541",
    "data-name": "Path 138541",
    d: "M368.493,337.384a.936.936,0,0,1,.627,1.078.9.9,0,0,1-1.064.631.986.986,0,0,1-.657-1.146.932.932,0,0,1,1.179-.534",
    transform: "translate(-108.773 -99.884)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138542",
    "data-name": "Path 138542",
    d: "M364.59,347.475l-.03-1.856-21.939.294s-1.028.425-.926,1.145Z",
    transform: "translate(-101.171 -102.335)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138543",
    "data-name": "Path 138543",
    d: "M358.362,338.412c0,.112.559.172,1.1.542s.828.845.933.8c.1-.02-.051-.691-.718-1.127s-1.34-.32-1.317-.217",
    transform: "translate(-106.108 -100.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138544",
    "data-name": "Path 138544",
    d: "M354.924,339.784c-.027.108.453.307.824.786s.472.982.584.979c.1.02.194-.634-.279-1.221s-1.124-.651-1.128-.544",
    transform: "translate(-105.09 -100.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138545",
    "data-name": "Path 138545",
    d: "M352.55,343.031c.1.025.267-.53-.009-1.147s-.794-.871-.843-.779c-.065.091.269.425.488.936s.253.977.365.99",
    transform: "translate(-104.133 -100.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138546",
    "data-name": "Path 138546",
    d: "M358.716,334.464c.045.1.561-.042,1.192.013s1.121.263,1.18.168c.066-.08-.407-.5-1.151-.556s-1.275.287-1.221.376",
    transform: "translate(-106.212 -98.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138547",
    "data-name": "Path 138547",
    d: "M397.83,320.838l1.24,14.225L396.806,346.6a1.463,1.463,0,0,0,2.51,1.274c2.041-2.225,9.508-10.447,9.358-11.484-.173-1.2-.312-15.091-.312-15.091Z",
    transform: "translate(-117.483 -94.998)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138548",
    "data-name": "Path 138548",
    d: "M398.6,354.466l10.555-12.9.038.6a2.2,2.2,0,0,1-.429,1.459c-.836,1.121-3.214,4.167-8.862,10.381a1.464,1.464,0,0,1-1.3.461",
    transform: "translate(-118.022 -101.134)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44505",
    "data-name": "Group 44505",
    transform: "translate(287.593 235.851)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44504",
    "data-name": "Group 44504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44503",
    "data-name": "Group 44503",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138549",
    "data-name": "Path 138549",
    d: "M408.885,335.227a.885.885,0,0,0-.168,1.169.85.85,0,0,0,1.157.176.933.933,0,0,0,.171-1.239.883.883,0,0,0-1.224-.05",
    transform: "translate(-408.567 -335.06)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_138550",
    "data-name": "Path 138550",
    d: "M401.4,350.121a3.155,3.155,0,0,0-2.981-1.237c-.015-.034.158-.156.488-.225a2.331,2.331,0,0,1,2.306.956c.185.282.221.491.187.505",
    transform: "translate(-117.969 -103.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138551",
    "data-name": "Path 138551",
    d: "M400.249,353.177a11.953,11.953,0,0,0-1.3-.531,11.681,11.681,0,0,0-1.4-.09,1.621,1.621,0,0,1,1.473-.216c.855.192,1.3.795,1.231.838",
    transform: "translate(-117.71 -104.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138552",
    "data-name": "Path 138552",
    d: "M403.393,346.487a7.512,7.512,0,0,0-4.1-1.314,4,4,0,0,1,4.1,1.314",
    transform: "translate(-118.228 -102.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138553",
    "data-name": "Path 138553",
    d: "M403.527,340.718c-.032.088-.841-.191-1.867-.162s-1.823.327-1.859.241a3.631,3.631,0,0,1,3.726-.079",
    transform: "translate(-118.378 -100.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138554",
    "data-name": "Path 138554",
    d: "M403.129,334.742a4.648,4.648,0,0,0-3.8.375c-.025-.028.118-.217.435-.428a3.189,3.189,0,0,1,2.853-.282c.351.144.529.3.51.334",
    transform: "translate(-118.238 -98.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138555",
    "data-name": "Path 138555",
    d: "M400.942,332.314a1.229,1.229,0,0,1-.054-.538,3.769,3.769,0,0,1,.338-1.439,1.669,1.669,0,0,1,.661-.838.589.589,0,0,1,.67.089.958.958,0,0,1,.267.629,2.068,2.068,0,0,1-1.687,2.025,2.4,2.4,0,0,1-2.431-1.1.834.834,0,0,1-.084-.688.578.578,0,0,1,.583-.344,2.052,2.052,0,0,1,.97.428,4.192,4.192,0,0,1,1.044,1.045,1.293,1.293,0,0,1,.251.478,6.69,6.69,0,0,0-1.418-1.338,1.91,1.91,0,0,0-.855-.352.306.306,0,0,0-.318.185.567.567,0,0,0,.081.449,2.141,2.141,0,0,0,2.119.931,1.8,1.8,0,0,0,1.456-1.7.693.693,0,0,0-.168-.447.318.318,0,0,0-.369-.053,1.5,1.5,0,0,0-.573.7,5.529,5.529,0,0,0-.484,1.881",
    transform: "translate(-118.016 -97.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138556",
    "data-name": "Path 138556",
    d: "M342.258,180.547a50.714,50.714,0,0,0-1.107,14.912c.244,3.169,10.937,90.835,10.937,90.835h14.439L362.468,203.9l1.182.256s7.882,35.14,8.525,40.831c.578,5.113,7.225,42.267,7.225,42.267l13.2.151-4.216-49.143-4.906-47.154-1.846-13.726Z",
    transform: "translate(-100.972 -52.522)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138557",
    "data-name": "Path 138557",
    d: "M371.568,198.237a2.789,2.789,0,0,1-.6.339,6.934,6.934,0,0,1-1.788.626,3.751,3.751,0,0,1-1.33.01,2.735,2.735,0,0,1-1.391-.668,3.3,3.3,0,0,1-.843-1.474c-.17-.561-.268-1.145-.386-1.737-.46-2.378-.773-4.549-.954-6.125-.091-.788-.151-1.427-.184-1.869a2.961,2.961,0,0,1-.018-.691,3.025,3.025,0,0,1,.136.676c.076.5.17,1.122.281,1.855.236,1.565.581,3.724,1.04,6.1a5.723,5.723,0,0,0,1.124,3.065,3,3,0,0,0,2.493.649,8.131,8.131,0,0,0,1.775-.521,3.291,3.291,0,0,1,.65-.231",
    transform: "translate(-107.795 -55.265)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138558",
    "data-name": "Path 138558",
    d: "M368.117,187.2c0-.013.094-.075.3-.088a1.292,1.292,0,0,1,.807.26,1.44,1.44,0,0,1,.608,1.115,1.431,1.431,0,0,1-2.437.914,1.443,1.443,0,0,1-.275-1.24,1.3,1.3,0,0,1,.438-.727c.161-.124.276-.141.282-.129a1.635,1.635,0,0,0-.507.9,1.26,1.26,0,0,0,.274,1.013,1.17,1.17,0,0,0,1.944-.729,1.259,1.259,0,0,0-.46-.943,1.629,1.629,0,0,0-.971-.342",
    transform: "translate(-108.69 -55.402)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138559",
    "data-name": "Path 138559",
    d: "M396.356,193.7a1.566,1.566,0,0,1-.491.077,9.161,9.161,0,0,1-1.354.016,13.11,13.11,0,0,1-8.106-3.414,9.126,9.126,0,0,1-.935-.98c-.2-.248-.3-.391-.289-.405.041-.036.5.5,1.366,1.223a14.561,14.561,0,0,0,7.98,3.361c1.123.108,1.827.069,1.829.123",
    transform: "translate(-114.049 -55.959)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138560",
    "data-name": "Path 138560",
    d: "M349.287,186.94a6.176,6.176,0,0,1-.75,1.473,16.538,16.538,0,0,1-5.68,5.522,6.19,6.19,0,0,1-1.492.708,15.269,15.269,0,0,1,1.379-.892,20.014,20.014,0,0,0,5.613-5.457,15.454,15.454,0,0,1,.93-1.354",
    transform: "translate(-101.076 -55.351)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138561",
    "data-name": "Path 138561",
    d: "M362.917,44.288l.577-.033a11.153,11.153,0,0,1,11.687,9.6c.743,5.353,1.5,11.275,1.625,14.162.27,5.98-5.652,7.252-5.652,7.252l.213,2.431a7.27,7.27,0,0,1-14.479,1.327l-2.123-22.184c-.892-6.173,1.958-11.838,8.153-12.558",
    transform: "translate(-104.996 -13.098)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138562",
    "data-name": "Path 138562",
    d: "M374.836,87.537a14.519,14.519,0,0,1-7.961-1.84s2.089,4.194,8.02,3.312Z",
    transform: "translate(-108.629 -25.374)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138563",
    "data-name": "Path 138563",
    d: "M380.745,65.486a.854.854,0,0,1-.773.908.818.818,0,0,1-.924-.719.855.855,0,0,1,.772-.909.818.818,0,0,1,.925.719",
    transform: "translate(-112.232 -19.175)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138564",
    "data-name": "Path 138564",
    d: "M380.83,61.819c-.1.118-.773-.324-1.691-.269s-1.564.553-1.67.447c-.052-.047.044-.254.325-.485a2.343,2.343,0,0,1,1.33-.495,2.251,2.251,0,0,1,1.354.353c.295.2.4.4.353.449",
    transform: "translate(-111.762 -18.066)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138565",
    "data-name": "Path 138565",
    d: "M369.464,66.287a.855.855,0,0,1-.774.908.817.817,0,0,1-.924-.719.855.855,0,0,1,.772-.909.818.818,0,0,1,.925.719",
    transform: "translate(-108.892 -19.412)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138566",
    "data-name": "Path 138566",
    d: "M368.022,62.8c-.1.118-.774-.324-1.691-.268s-1.565.553-1.67.446c-.052-.047.043-.254.325-.484a2.348,2.348,0,0,1,1.33-.5,2.258,2.258,0,0,1,1.354.353c.294.2.4.4.353.449",
    transform: "translate(-107.969 -18.356)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138567",
    "data-name": "Path 138567",
    d: "M374.367,69.332a6.064,6.064,0,0,1,1.475-.355c.233-.037.453-.1.483-.259a1.191,1.191,0,0,0-.2-.686l-.8-1.746a30.709,30.709,0,0,1-1.826-4.58,30.8,30.8,0,0,1,2.19,4.423c.268.614.524,1.2.768,1.758a1.36,1.36,0,0,1,.175.913.589.589,0,0,1-.366.365,1.6,1.6,0,0,1-.395.078,6.04,6.04,0,0,1-1.511.089",
    transform: "translate(-110.59 -18.27)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138568",
    "data-name": "Path 138568",
    d: "M367.732,57.759c-.076.255-1,.189-2.069.381-1.073.17-1.924.536-2.08.32-.07-.1.068-.347.405-.609a3.656,3.656,0,0,1,3.161-.534c.4.137.615.321.583.442",
    transform: "translate(-107.649 -16.926)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138569",
    "data-name": "Path 138569",
    d: "M380.234,58.047c-.149.218-.795.038-1.556.071-.762.007-1.4.221-1.557.011-.071-.1.018-.317.288-.53a2.255,2.255,0,0,1,2.509-.067c.281.2.381.409.316.515",
    transform: "translate(-111.656 -16.932)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138570",
    "data-name": "Path 138570",
    d: "M373.828,50.821s-1.791-3.651-3.646-4.421c-2.245-.931-3.048,1.52-5.162,1.058s-4.259-1.356-6.294.375c-2.227,1.895-1.065,3.068-1.057,5.728.035,10.782-1.753,13.934-2.6,8.9-.093-.551-1.658-.9-2.021-3.234-.47-3.022-.8-6.7-.245-8.9a8.515,8.515,0,0,1,3.21-4.657c2.808-2.355,6.835-2.633,9.587-2.515s8.209,2.963,8.229,7.663",
    transform: "translate(-104.376 -12.772)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138571",
    "data-name": "Path 138571",
    d: "M355,69.71a1.624,1.624,0,0,0-1.841-1.462c-1.109.17-2.312.874-2.106,3.173.365,4.077,4.384,2.869,4.38,2.752,0-.08-.265-2.757-.434-4.462",
    transform: "translate(-103.938 -20.202)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138572",
    "data-name": "Path 138572",
    d: "M355,73.277c-.019-.011-.067.056-.182.122a.714.714,0,0,1-.53.058,1.763,1.763,0,0,1-.955-1.5,2.35,2.35,0,0,1,.108-1.035.825.825,0,0,1,.485-.593.364.364,0,0,1,.437.158c.065.108.046.192.068.2s.082-.077.034-.242a.458.458,0,0,0-.184-.241.535.535,0,0,0-.4-.068,1,1,0,0,0-.686.7,2.433,2.433,0,0,0-.144,1.159,1.851,1.851,0,0,0,1.194,1.668.764.764,0,0,0,.641-.166c.117-.112.13-.2.115-.211",
    transform: "translate(-104.532 -20.761)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138573",
    "data-name": "Path 138573",
    d: "M374.471,45.428c-.628-.472-1.491-.54-2.115-1.017-1.135-.869-1.183-2.847-2.515-3.364-.79-.306-1.679.071-2.521-.016-1.363-.141-1.89-1.172-3.961-1.178a3.759,3.759,0,0,0-3.553,2,3.1,3.1,0,0,0-3.1.292,3.448,3.448,0,0,0-1.3,2.473s-.426-.214-1.717.806a6.732,6.732,0,0,0-1.791,3.051c-.445,1.5.2,3.073.841,4.5a3.121,3.121,0,0,0,1.572,1.888,2.114,2.114,0,0,0,2.429-1.39c.381-.956.984-1.917,1.447-2.837.8-1.6,1.626-3.085.95-4.106a4.655,4.655,0,0,1,2.873-.017c.936.31,1.753.911,2.683,1.24a2.506,2.506,0,0,0,2.742-.447,2,2,0,0,0,3.065.664A2.8,2.8,0,0,0,374.166,49a2.272,2.272,0,0,0,.3-3.57",
    transform: "translate(-104.153 -11.8)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138574",
    "data-name": "Path 138574",
    d: "M352.579,57.051a4.953,4.953,0,0,1,.473.934,2,2,0,0,0,.673.826,1.779,1.779,0,0,0,1.265.146,3.072,3.072,0,0,0,1.224-.517,4.872,4.872,0,0,0,.8-.769,6.24,6.24,0,0,1,.683-.795,3.54,3.54,0,0,1-.548.9,4.357,4.357,0,0,1-.8.842,3.1,3.1,0,0,1-1.312.576A1.948,1.948,0,0,1,353.6,59a2.059,2.059,0,0,1-.708-.943,4.128,4.128,0,0,1-.317-1.007",
    transform: "translate(-104.395 -16.84)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138575",
    "data-name": "Path 138575",
    d: "M352.8,60.64a3.389,3.389,0,0,0,.807.447,2.289,2.289,0,0,0,.975.084,2.785,2.785,0,0,0,1.122-.428,5.6,5.6,0,0,0,1.536-1.618,4.476,4.476,0,0,1,.556-.773,3.216,3.216,0,0,1-.41.864,4.959,4.959,0,0,1-1.551,1.732,2.827,2.827,0,0,1-1.228.445,2.277,2.277,0,0,1-1.059-.145c-.578-.237-.772-.6-.749-.609",
    transform: "translate(-104.461 -17.278)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138576",
    "data-name": "Path 138576",
    d: "M370.928,74.674a5.168,5.168,0,0,0-.231,1.374,1.563,1.563,0,0,0,.445,1.205,1.717,1.717,0,0,0,1.323.61h.015a1.908,1.908,0,0,0,1.882-1.623l.162-1.013c-.959-.26-3.524-.487-3.6-.554",
    transform: "translate(-109.758 -22.11)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138577",
    "data-name": "Path 138577",
    d: "M373.375,77.516c-.006-.019-.12.006-.327.034a2.794,2.794,0,0,1-.862.006,1.679,1.679,0,0,1-1.051-.613,2.21,2.21,0,0,1-.194-2.263l-.127.063c.918.139,1.721.249,2.3.317a3.913,3.913,0,0,0,.925.066,3.913,3.913,0,0,0-.9-.221c-.567-.111-1.366-.253-2.281-.4l-.086-.014-.041.077a2.382,2.382,0,0,0,.232,2.525,1.817,1.817,0,0,0,1.2.641,2.386,2.386,0,0,0,.907-.087c.206-.059.31-.115.306-.129",
    transform: "translate(-109.693 -22.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138578",
    "data-name": "Path 138578",
    d: "M355.225,70.795a.844.844,0,0,0-1.157-.389c-.465.26-.554.631-.681,1.149a1.4,1.4,0,0,0,.139,1.092.9.9,0,0,0,.976.4,1.285,1.285,0,0,0,.724-.9,1.788,1.788,0,0,0,0-1.349",
    transform: "translate(-104.621 -20.814)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138579",
    "data-name": "Path 138579",
    d: "M362.767,78.329a8.843,8.843,0,0,1-3.673-.789,8.944,8.944,0,0,1-4.8-5.556l.676-.2A8.123,8.123,0,0,0,366.145,76.9l.293.64a8.844,8.844,0,0,1-3.671.788",
    transform: "translate(-104.903 -21.256)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138580",
    "data-name": "Path 138580",
    d: "M371.51,80.155l-1.466.289a1.122,1.122,0,0,1-1.318-.885l-.008-.038A1.123,1.123,0,0,1,369.6,78.2l1.466-.289a1.122,1.122,0,0,1,1.318.885l.008.039a1.122,1.122,0,0,1-.885,1.318",
    transform: "translate(-109.168 -23.063)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138581",
    "data-name": "Path 138581",
    d: "M354.883,70.472a3.486,3.486,0,0,0,.815-1.2,1.649,1.649,0,0,0-.1-1.413,2.01,2.01,0,0,0-1-.74,2.457,2.457,0,0,0-1.08-.2,1.3,1.3,0,0,0-.957.489.476.476,0,0,0-.056.561c.146.177.424.13.646.073a2.646,2.646,0,0,1,.93-.113,1.053,1.053,0,0,1,.793.445,1.077,1.077,0,0,1-.014,1.034,3.17,3.17,0,0,1-.689.826",
    transform: "translate(-104.354 -19.812)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138582",
    "data-name": "Path 138582",
    d: "M329.9,102.792a10.843,10.843,0,0,0-6.742,6.993c-1.331,4.97-4.968,23.167-4.968,23.167l-3.855,5.339s1.248,9.756,8.345,7.9a5.575,5.575,0,0,0,6.244-3.975c1.508-4.8,4.435-19.124,4.435-19.124Z",
    transform: "translate(-93.073 -30.436)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138583",
    "data-name": "Path 138583",
    d: "M351.216,90.957l-2.68,4.055-12.087,4.276,3.46,35.045L338.616,152.7a4.145,4.145,0,0,0,4.249,4.435l37.984-1.122c.952-.026,1.4-1.229,1.553-2.527a8.8,8.8,0,0,0-.3-3.474l-2-7.028c.3,4.373-1.012-26.077-1.063-27.186l2.928-15.669-13.752-5.56-2.129-3.286-6.187,4.706Z",
    transform: "translate(-99.62 -26.932)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138584",
    "data-name": "Path 138584",
    d: "M399.653,103.989s2.767,2.429,3.231,4.28,10.4,23.4,10.4,23.4L418.23,133l1.317,2.735a7.617,7.617,0,0,1-2.153,9.37,5.525,5.525,0,0,1-.529.36,8.419,8.419,0,0,1-10.265-1.775c-2.648-3.124-10.4-14.363-10.4-14.363V115.583Z",
    transform: "translate(-117.313 -30.79)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138585",
    "data-name": "Path 138585",
    d: "M423.48,144.637l7.105-4.193,3.423,4.193-.708,2.03-9.159,6.8a6.1,6.1,0,0,1-2.124-3.684c-.429-2.547,1.463-5.146,1.463-5.146",
    transform: "translate(-124.937 -41.584)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138586",
    "data-name": "Path 138586",
    d: "M417.968,143.291c0,.066-.6.015-1.494.3a6.632,6.632,0,0,0-2.952,2.046,13.533,13.533,0,0,0-1.878,3.153,8.02,8.02,0,0,1-.673,1.394,5.543,5.543,0,0,1,.434-1.494,11.184,11.184,0,0,1,1.838-3.291,6.239,6.239,0,0,1,3.161-2.058,2.775,2.775,0,0,1,1.565-.051",
    transform: "translate(-121.683 -42.405)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138587",
    "data-name": "Path 138587",
    d: "M434,139.285a5.536,5.536,0,0,1,1.706-5.119,19.32,19.32,0,0,1,5.611-3.215c1.247-.557,3.838-2.723,4.3-2.2a1.717,1.717,0,0,1,0,2.264c-.656.952-4.415,2.381-3.89,3.587.215.494,1.4.58,1.4.58s4.528.3,6.432.132,3.609.2,3.51.853-.459,1.017-2.034,1.148-4.134.033-4.265.394.393.591,1.312.524,5.25-.065,5.545.427a.977.977,0,0,1-.525,1.411l-1.017.361s.591.82.1,1.279-1.608.3-1.608.3l-5.742-.164s-.328.346-.164.583,4.659-.091,4.692.4.427.722-.919,1.05a18.038,18.038,0,0,1-5.939,0,59.464,59.464,0,0,0-6.3-.558Z",
    transform: "translate(-128.477 -38.099)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138588",
    "data-name": "Path 138588",
    d: "M318.8,145.147l-6.642-5.514-3.815,4.288.467,2.1,8.3,7.82a5.771,5.771,0,0,0,2.609-3.186c.826-2.354-.923-5.506-.923-5.506",
    transform: "translate(-91.299 -41.344)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138589",
    "data-name": "Path 138589",
    d: "M305.407,138.684a5.536,5.536,0,0,0-1.1-5.283,19.3,19.3,0,0,0-5.2-3.848c-1.173-.7-3.495-3.152-4.013-2.684a1.717,1.717,0,0,0-.263,2.248c.541,1.021,3.123,2.217,3.031,3.529a.97.97,0,0,1-1.04.9s-4.532-.234-6.4-.619-3.608-.225-3.586.438.338,1.064,1.887,1.378,4.1.515,4.19.888-.46.541-1.365.369-5.206-.677-5.557-.223a.977.977,0,0,0,.357,1.463l.968.477s-.682.745-.247,1.259,1.563.481,1.563.481l5.722.506s.285.382.1.6-4.617-.634-4.707-.149-.508.667.79,1.15a18.048,18.048,0,0,0,5.9.692,59.4,59.4,0,0,1,6.322.18Z",
    transform: "translate(-84.624 -37.548)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138590",
    "data-name": "Path 138590",
    d: "M377.757,97.511a9.387,9.387,0,0,1-1.193,1.242c-.757.743-1.793,1.775-2.891,2.961l-.676.738-.146.159-.131-.168c-.85-1.091-1.585-2.061-2.1-2.764a5.909,5.909,0,0,1-.771-1.17,5.914,5.914,0,0,1,.957,1.023c.565.664,1.335,1.606,2.2,2.688l-.277-.008.676-.746a39.131,39.131,0,0,1,2.984-2.9,7.055,7.055,0,0,1,1.369-1.051",
    transform: "translate(-109.509 -28.872)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138591",
    "data-name": "Path 138591",
    d: "M337.563,115.994a3.088,3.088,0,0,1,.2.743c.1.481.232,1.184.372,2.054.281,1.74.578,4.158.825,6.834s.429,5.1.565,6.855q.089,1.222.15,2.079a3.08,3.08,0,0,1,.011.768,3.074,3.074,0,0,1-.152-.752c-.075-.487-.166-1.195-.266-2.069-.2-1.75-.425-4.172-.672-6.846s-.5-5.087-.717-6.832q-.15-1.214-.255-2.067a3.114,3.114,0,0,1-.055-.766",
    transform: "translate(-99.947 -34.345)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138592",
    "data-name": "Path 138592",
    d: "M397.252,114.258a4.621,4.621,0,0,1,.13.933c.061.6.125,1.477.182,2.559.12,2.162.182,5.154.19,8.455v8.452c0,1.026,0,1.884,0,2.562a4.63,4.63,0,0,1-.041.941,4.63,4.63,0,0,1-.1-.937c-.043-.6-.082-1.48-.118-2.562-.073-2.164-.1-5.154-.108-8.455s-.029-6.287-.082-8.447c-.026-1.025-.048-1.883-.065-2.56a4.673,4.673,0,0,1,.013-.942",
    transform: "translate(-117.617 -33.831)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138593",
    "data-name": "Path 138593",
    d: "M327.02,154.086a14.63,14.63,0,0,1-.371-1.86,14.535,14.535,0,0,0-1.434-4.27,7.934,7.934,0,0,0-3.1-3.15,13.665,13.665,0,0,0-1.745-.679,1.224,1.224,0,0,1,.516.023,5.042,5.042,0,0,1,1.345.424,7.573,7.573,0,0,1,3.309,3.2,12.712,12.712,0,0,1,1.37,4.406,7.39,7.39,0,0,1,.115,1.9",
    transform: "translate(-94.858 -42.67)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138594",
    "data-name": "Path 138594",
    d: "M329.689,147.009a9.441,9.441,0,0,0-6.139-2.1,6.059,6.059,0,0,1,6.139,2.1",
    transform: "translate(-95.801 -42.848)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138595",
    "data-name": "Path 138595",
    d: "M370.574,158.573a3.665,3.665,0,0,1-.039-.6q-.015-.64-.041-1.722c-.03-1.53-.072-3.684-.125-6.33-.126-5.376-.3-12.746-.49-20.886-.187-8.159-.3-15.548-.288-20.9,0-2.675.027-4.839.062-6.334q.032-1.082.051-1.722a3.738,3.738,0,0,1,.043-.6,3.638,3.638,0,0,1,.031.6q.007.64.018,1.722c.013,1.531.032,3.685.054,6.331.057,5.346.209,12.732.4,20.89s.34,15.542.382,20.891c.025,2.674.024,4.839.009,6.334q-.018,1.083-.028,1.722a3.715,3.715,0,0,1-.034.6",
    transform: "translate(-109.433 -29.456)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138596",
    "data-name": "Path 138596",
    d: "M322.019,147.139a2.823,2.823,0,0,1,.97,1.251,6.307,6.307,0,0,1,.566,1.639,6.887,6.887,0,0,1,.028,2.127,5.775,5.775,0,0,1-.622,2.041,4.022,4.022,0,0,1-1.163,1.308,2.275,2.275,0,0,1-1.492.538,6.356,6.356,0,0,0,1.335-.744,4.085,4.085,0,0,0,1.023-1.264,5.892,5.892,0,0,0,.556-1.928,7.241,7.241,0,0,0,0-2.02,7.048,7.048,0,0,0-.469-1.589,15.237,15.237,0,0,0-.735-1.361",
    transform: "translate(-94.84 -43.566)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138597",
    "data-name": "Path 138597",
    d: "M425.358,155.968c-.008.021-.17-.017-.444-.132a4.978,4.978,0,0,1-1.08-.65,5.824,5.824,0,0,1-1.462-7.573,4.962,4.962,0,0,1,.762-1.006c.211-.21.346-.3.363-.289.049.045-.431.5-.9,1.418a5.913,5.913,0,0,0,1.4,7.25c.774.68,1.388.923,1.359.983",
    transform: "translate(-124.823 -43.323)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138598",
    "data-name": "Path 138598",
    d: "M377.935,137.162a5.959,5.959,0,0,1-.919.538c-.6.327-1.482.78-2.578,1.325-2.191,1.09-5.254,2.526-8.693,3.983s-6.6,2.655-8.912,3.47c-1.154.408-2.093.724-2.745.929a5.909,5.909,0,0,1-1.026.285,5.843,5.843,0,0,1,.978-.42l2.7-1.038c2.282-.875,5.424-2.111,8.859-3.564s6.507-2.85,8.724-3.879l2.627-1.218a5.922,5.922,0,0,1,.982-.41",
    transform: "translate(-104.539 -40.612)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138599",
    "data-name": "Path 138599",
    d: "M444.782,134.86c.043.042-.266.339-.66.86a2.454,2.454,0,0,0-.453,1.008c-.086.413-.08.9-.151,1.427a3.479,3.479,0,0,1-1.37,2.311,1.74,1.74,0,0,1-1.025.438c-.023-.057.373-.207.862-.639a3.574,3.574,0,0,0,1.17-2.16,14.036,14.036,0,0,1,.184-1.45,2.479,2.479,0,0,1,.58-1.1c.474-.512.835-.726.863-.7",
    transform: "translate(-130.613 -39.93)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138600",
    "data-name": "Path 138600",
    d: "M295.848,142.707a28.955,28.955,0,0,1-7.966-.378,87.819,87.819,0,0,1,7.966.378",
    transform: "translate(-85.24 -42.13)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138601",
    "data-name": "Path 138601",
    d: "M304.158,139.889c-.008.037-.427-.032-.931-.46a2.933,2.933,0,0,1-1.011-2.293,7.189,7.189,0,0,1,.248-1.353,3.872,3.872,0,0,0,.135-1.046,3.489,3.489,0,0,0-.222-.944c.021-.042.393.247.481.922a3.462,3.462,0,0,1-.063,1.138,9.194,9.194,0,0,0-.213,1.3,2.95,2.95,0,0,0,.824,2.091c.415.438.779.593.752.648",
    transform: "translate(-89.484 -39.614)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138602",
    "data-name": "Path 138602",
    d: "M447.775,144.239a49.461,49.461,0,0,1,8.487.707,49.654,49.654,0,0,1-8.487-.707",
    transform: "translate(-132.583 -42.695)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138603",
    "data-name": "Path 138603",
    d: "M364.724,98a13.466,13.466,0,0,1-.81,2.08l-.448,1.033a11.773,11.773,0,0,1-.565,1.2.769.769,0,0,1-.757.367,1.886,1.886,0,0,1-.712-.365l-1.264-.867c-1.73-1.193-3.284-2.29-4.4-3.1a13.469,13.469,0,0,1-1.76-1.371,13.414,13.414,0,0,1,1.908,1.158c1.152.755,2.73,1.817,4.46,3.01l1.26.874a1.677,1.677,0,0,0,.565.315.422.422,0,0,0,.424-.218c.407-.741.746-1.54,1.052-2.141A13.528,13.528,0,0,1,364.724,98",
    transform: "translate(-104.819 -28.713)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_138604",
    "data-name": "Path 138604",
    d: "M200.171,404.241l-.452-14.26H210.3l-.7,14.562-4.78,1.868Z",
    transform: "translate(-59.135 -115.47)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44512",
    "data-name": "Group 44512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44511",
    "data-name": "Group 44511",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138605",
    "data-name": "Path 138605",
    d: "M201.484,410.457l-4.007-.218s-6.164,4.989-6.758,7.726a6.142,6.142,0,0,0,0,2.1l9.361.272c1.886,0,6.83.008,6.83.008v-9.8Z",
    transform: "translate(-56.443 -121.469)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18641",
    "data-name": "Rectangle 18641",
    width: 16.276,
    height: 1.699,
    transform: "translate(134.191 297.173)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138606",
    "data-name": "Path 138606",
    d: "M200.931,411.32c.1.03-.327,1.7-.664,3.795s-.469,3.813-.577,3.81a18.251,18.251,0,0,1,1.241-7.6",
    transform: "translate(-59.107 -121.789)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138607",
    "data-name": "Path 138607",
    d: "M209.137,419.907a8.541,8.541,0,0,0-.848-1.541,4.535,4.535,0,0,0-1.426-1.2,4.341,4.341,0,0,0-4.355.206A4.546,4.546,0,0,0,201.2,418.7a8.543,8.543,0,0,0-.7,1.613,1.041,1.041,0,0,1,.02-.489,4.081,4.081,0,0,1,.457-1.257,4.433,4.433,0,0,1,7.519-.355,4.067,4.067,0,0,1,.574,1.209,1.028,1.028,0,0,1,.066.486",
    transform: "translate(-59.362 -123.266)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138608",
    "data-name": "Path 138608",
    d: "M235.538,404.4l2.111-14.111-10.512-1.233-1,14.543,4.53,2.413Z",
    transform: "translate(-66.957 -115.197)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138609",
    "data-name": "Path 138609",
    d: "M231.053,410.268l4,.25s5.54,5.674,5.811,8.462a6.138,6.138,0,0,1-.244,2.082l-9.329-.821c-1.872-.22-6.784-.788-6.784-.788l1.142-9.734Z",
    transform: "translate(-66.476 -121.315)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18642",
    "data-name": "Rectangle 18642",
    width: 1.699,
    height: 16.276,
    transform: "translate(158.036 298.138) rotate(-83.307)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138610",
    "data-name": "Path 138610",
    d: "M238.243,411.8a18.224,18.224,0,0,1,.346,7.7c-.106-.009-.028-1.732-.127-3.851s-.324-3.828-.218-3.846",
    transform: "translate(-70.534 -121.93)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138611",
    "data-name": "Path 138611",
    d: "M225.855,419.206a1.028,1.028,0,0,1,.122-.474,4.05,4.05,0,0,1,.71-1.133,4.432,4.432,0,0,1,7.426,1.228,4.069,4.069,0,0,1,.308,1.3,1.024,1.024,0,0,1-.037.488,8.45,8.45,0,0,0-.507-1.684,4.533,4.533,0,0,0-1.142-1.475,4.343,4.343,0,0,0-4.3-.712,4.539,4.539,0,0,0-1.556,1.028,8.518,8.518,0,0,0-1.022,1.431",
    transform: "translate(-66.872 -123.205)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138612",
    "data-name": "Path 138612",
    d: "M192.156,346.871c0,.626,2.381,35.065,2.381,35.065h15.24l1.63-35.561Z",
    transform: "translate(-56.896 -102.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138613",
    "data-name": "Path 138613",
    d: "M242.6,346.021l-4,36.312-14.919-1.206.971-36.121Z",
    transform: "translate(-66.231 -102.154)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138614",
    "data-name": "Path 138614",
    d: "M223.673,185.458l-.291-.115A5.707,5.707,0,0,0,219.1,182a7.4,7.4,0,0,0-5.383,1.268c-1.085.74-1.991,1.72-3.079,2.455a4.327,4.327,0,0,1-3.715.788c-.216.455.636.848.519,1.338a.587.587,0,0,1-.559.376,6.416,6.416,0,0,1-1.046-.139.848.848,0,0,0-.9.406,1.03,1.03,0,0,0-.022.512,9.125,9.125,0,0,0,1.561,4.312,4.78,4.78,0,0,0,3.959,2.032,7.607,7.607,0,0,0,3.392-1.384l6-3.678a12.339,12.339,0,0,0,2.6-1.927,4.16,4.16,0,0,0,1.249-2.9",
    transform: "translate(-60.668 -53.86)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138615",
    "data-name": "Path 138615",
    d: "M229.9,186.782a6.012,6.012,0,0,1,2.694-.937,3.572,3.572,0,0,1,2.664.864,7.974,7.974,0,0,1,1.406,2.263,3.332,3.332,0,0,0,1.859,1.823.779.779,0,0,1,.42.194c.175.215-.015.565-.28.648a1.294,1.294,0,0,1-.809-.11,2.907,2.907,0,0,0,1.586,1.177,1.259,1.259,0,0,1-1.643.691,13.019,13.019,0,0,1,.109,3.193,4.37,4.37,0,0,1-1.39,2.805c-.9.756-2.251,1.074-2.738,2.144",
    transform: "translate(-68.073 -55.025)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138616",
    "data-name": "Path 138616",
    d: "M211.726,225.161l14.2,1.6-.066-12.27s.995-.085,1.72-5.329,2.086-14.136,2.086-14.136a18.4,18.4,0,0,0-18.63,0l-.853.5Z",
    transform: "translate(-62.234 -56.996)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138617",
    "data-name": "Path 138617",
    d: "M209.756,206.132c-.084-.05-3.474-1.52-3.811,2.084s3.352,3.2,3.368,3.1.443-5.18.443-5.18",
    transform: "translate(-60.972 -60.934)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138618",
    "data-name": "Path 138618",
    d: "M234.956,208.2c.094-.027,3.4-.489,2.837,3.088s-4.039,2.27-4.029,2.167,1.192-5.255,1.192-5.255",
    transform: "translate(-69.216 -61.638)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138619",
    "data-name": "Path 138619",
    d: "M209.786,201.307c.158,3.076-.146,4.643.1,6.715a10.67,10.67,0,0,0,4.324,7.863c2.665,1.948,6.544,2.406,9.275.553a8.468,8.468,0,0,0,3.857-5.055c.537-2.227,1.736-6.386,2.038-8.657.543-4.1.868-7.789.868-7.789L218.8,191.346l-7.162,3.125Z",
    transform: "translate(-62.116 -56.656)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138620",
    "data-name": "Path 138620",
    d: "M222.494,229.436a5.276,5.276,0,0,1-3.959-.947c.044-.086.876.294,1.961.549s2,.3,2,.4",
    transform: "translate(-64.706 -67.65)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138621",
    "data-name": "Path 138621",
    d: "M209.676,204.585c.044-3.127.265-6.681.191-9.991a20.949,20.949,0,0,1,.022-4.27c.264-1.219.553-.8,1.236-1.846.856-1.31,3.575-1.912,5.136-2.027s1.915-1.407,2.954-.237a3.833,3.833,0,0,1,6.731,2.474,2.661,2.661,0,0,1,4.024,3.194,2.6,2.6,0,0,1,1.245,4.169c-.648.767-1.684,1.1-2.382,1.826a3.02,3.02,0,0,0-.587,3.218",
    transform: "translate(-62.084 -54.749)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138622",
    "data-name": "Path 138622",
    d: "M230,214.645a6.91,6.91,0,0,1-2.916,5.514A11.99,11.99,0,0,0,230,214.645",
    transform: "translate(-67.236 -63.555)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138623",
    "data-name": "Path 138623",
    d: "M233.225,211.2a5.581,5.581,0,0,1-1.668,5.3,9.623,9.623,0,0,0,1.668-5.3",
    transform: "translate(-68.561 -62.536)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138624",
    "data-name": "Path 138624",
    d: "M215.193,189.688a8.092,8.092,0,0,1,4.064-2.809,4.729,4.729,0,0,1,4.63,1.183",
    transform: "translate(-63.717 -55.284)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138625",
    "data-name": "Path 138625",
    d: "M214.016,199.442a2.977,2.977,0,0,0,.018-1.074,13.68,13.68,0,0,1,.041-2.522,5.566,5.566,0,0,1,.836-2.313c.352-.53.673-.786.632-.84-.024-.041-.424.136-.869.662a4.823,4.823,0,0,0-1.014,2.433,8.921,8.921,0,0,0,.08,2.611,2.671,2.671,0,0,0,.277,1.042",
    transform: "translate(-63.244 -57.053)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138626",
    "data-name": "Path 138626",
    d: "M217.1,202.965a26.027,26.027,0,0,0-.631-3.415,2.84,2.84,0,0,0-.04,1.773c.177.974.568,1.686.671,1.642",
    transform: "translate(-64.054 -59.085)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138627",
    "data-name": "Path 138627",
    d: "M233.279,201.2a3.052,3.052,0,0,0,.967-1.182,6.383,6.383,0,0,0-.511-7.046,3.053,3.053,0,0,0-1.128-1.03c-.046.051.384.44.886,1.2a6.785,6.785,0,0,1,.489,6.738c-.386.827-.757,1.274-.7,1.318",
    transform: "translate(-68.872 -56.833)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138628",
    "data-name": "Path 138628",
    d: "M217.761,183.359a5.121,5.121,0,0,0,1.217-.341,6.878,6.878,0,0,1,2.911-.338,3.449,3.449,0,0,1,2.425,1.4,7.589,7.589,0,0,1,.527,1.106c.044.009.129-.532-.275-1.263a3.18,3.18,0,0,0-.976-1.05,3.871,3.871,0,0,0-1.643-.609,6,6,0,0,0-3.069.474,3.135,3.135,0,0,0-1.117.621",
    transform: "translate(-64.477 -53.954)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138629",
    "data-name": "Path 138629",
    d: "M237.549,190.151c.048-.011.013-.423-.3-1a3.9,3.9,0,0,0-4.4-1.9c-.636.171-.959.429-.934.47a6.791,6.791,0,0,0,.992-.18A4.153,4.153,0,0,1,237,189.3c.351.5.487.867.55.846",
    transform: "translate(-68.67 -55.407)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138630",
    "data-name": "Path 138630",
    d: "M228.26,207.571c.02-.048-.553-.279-1.444-.822a12.26,12.26,0,0,1-3.172-2.78l-.6-.744.261.921a7.952,7.952,0,0,1,.294,1.77c.021.3.02.681-.1.716-.091.082-.392-.12-.636-.342a10.85,10.85,0,0,1-2.142-2.433l-.53-.824.169.962c.168.962.326,1.858.468,2.67l.291-.13a16.052,16.052,0,0,1-1.932-3.177,3.017,3.017,0,0,0,.286.986,9.831,9.831,0,0,0,1.389,2.4l.384.492-.094-.622c-.122-.815-.258-1.715-.4-2.68l-.362.137a10.712,10.712,0,0,0,2.206,2.543,3.484,3.484,0,0,0,.432.327.68.68,0,0,0,.681.057.706.706,0,0,0,.31-.591,4.649,4.649,0,0,0-.01-.511,8,8,0,0,0-.332-1.856l-.335.176a11.225,11.225,0,0,0,3.355,2.74,5.019,5.019,0,0,0,1.561.619",
    transform: "translate(-64.9 -60.116)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138631",
    "data-name": "Path 138631",
    d: "M224.771,188.268a1.857,1.857,0,0,1,1.242-.731,3.238,3.238,0,0,1,1.461.148,5.26,5.26,0,0,1,2.833,2.151c.15.232.266.576.053.752a.6.6,0,0,1-.419.087,22.657,22.657,0,0,1-5.27-.852",
    transform: "translate(-66.524 -55.519)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138632",
    "data-name": "Path 138632",
    d: "M198.585,237.334s-14.708,3.749-17.16,7.642-3.893,12.834-3.893,14.42-.289,19.611,2.74,25.523,54.219,4.182,54.219,4.182,3.893-2.019,4.9-8.075-.865-26.244-1.875-30.714-1.874-3.173-6.633-6.056a108.736,108.736,0,0,0-12.113-5.912l-2.6-4.9s-8.22-4.471-14.709-.721Z",
    transform: "translate(-52.564 -68.463)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138633",
    "data-name": "Path 138633",
    d: "M252.485,266.748c.1,0,.131,3.919.067,8.748s-.2,8.745-.3,8.744-.132-3.918-.067-8.749.2-8.745.3-8.743",
    transform: "translate(-74.66 -78.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138634",
    "data-name": "Path 138634",
    d: "M188,262.581a2.822,2.822,0,0,1,.01.733q-.036.826-.085,1.986c-.073,1.676-.144,3.992-.126,6.55s.125,4.874.222,6.549q.068,1.159.115,1.984a2.87,2.87,0,0,1,0,.733,2.784,2.784,0,0,1-.144-.719c-.07-.465-.149-1.141-.231-1.979-.164-1.674-.311-4-.331-6.566s.094-4.892.234-6.569c.069-.838.139-1.516.2-1.982a2.814,2.814,0,0,1,.132-.721",
    transform: "translate(-55.496 -77.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138635",
    "data-name": "Path 138635",
    d: "M230.023,251.349a1.416,1.416,0,0,1-.372-.017l-1.054-.118-3.875-.446c-3.272-.358-7.806-.749-12.825-.925s-9.571-.094-12.861.036l-3.9.177-1.06.045a1.42,1.42,0,0,1-.372-.009,1.454,1.454,0,0,1,.366-.064l1.056-.114c.917-.094,2.248-.2,3.894-.294,3.291-.2,7.852-.315,12.886-.144s9.572.61,12.843,1.034c1.636.21,2.956.405,3.864.563l1.046.187a1.412,1.412,0,0,1,.36.089",
    transform: "translate(-57.356 -73.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138636",
    "data-name": "Path 138636",
    d: "M226.744,240.561c-.013.056-1.095-.153-2.853-.412a62.721,62.721,0,0,0-13.842-.524c-1.773.126-2.868.253-2.876.2a3.153,3.153,0,0,1,.758-.17c.491-.089,1.207-.187,2.095-.283a49.31,49.31,0,0,1,13.907.526c.878.163,1.584.315,2.067.441a3.173,3.173,0,0,1,.743.227",
    transform: "translate(-61.342 -70.797)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44510",
    "data-name": "Group 44510",
    transform: "translate(126.406 200.226)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44509",
    "data-name": "Group 44509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44508",
    "data-name": "Group 44508",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138637",
    "data-name": "Path 138637",
    d: "M234.22,286.636a10.437,10.437,0,0,0-4.615-1.056c-9.229-.638-18.482-.839-27.731-1.039a114.672,114.672,0,0,0-15.931.395,8.127,8.127,0,0,0-4.649,1.64c-1.659,1.517-1.888,4.049-1.626,6.282s.9,4.474.546,6.694l55.5,5.246c-.08-3.232,1.155-6.343,1.577-9.548s-.276-6.981-3.067-8.614",
    transform: "translate(-179.577 -284.45)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_138638",
    "data-name": "Path 138638",
    d: "M190.427,332.493a9.388,9.388,0,0,1-9.407-9.092c-.26-9.522-.267-24.269-.256-30.664a3.14,3.14,0,0,1,3.144-3.135h48.924a3.14,3.14,0,0,1,3.143,3.215c-.161,6.638-.535,22.035-.767,31.579a8.3,8.3,0,0,1-8.3,8.1Z",
    transform: "translate(-53.522 -85.749)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138639",
    "data-name": "Path 138639",
    d: "M177.514,402.615l-2.8-.341,5.76-47.125a5.468,5.468,0,0,1,5.386-4.851h41.256a5.47,5.47,0,0,1,5.383,4.832c1.38,11.14,5.223,46.8,5.261,47.163l-2.8.3c-.039-.359-3.879-36-5.256-47.118a2.652,2.652,0,0,0-2.59-2.363H185.865a2.65,2.65,0,0,0-2.59,2.374Z",
    transform: "translate(-51.733 -103.721)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138640",
    "data-name": "Path 138640",
    d: "M177.5,402.542s.023-.257.078-.744.14-1.213.25-2.155c.225-1.9.555-4.68.98-8.269.86-7.173,2.1-17.551,3.648-30.412q.291-2.41.6-4.934a5.6,5.6,0,0,1,.235-1.285,2.874,2.874,0,0,1,.744-1.121,2.733,2.733,0,0,1,1.2-.643,5.94,5.94,0,0,1,1.348-.077l11.055-.01,24.441-.018h4.894a2.754,2.754,0,0,1,1.656.472,2.845,2.845,0,0,1,1.072,1.367,7.651,7.651,0,0,1,.281,1.683q.186,1.665.375,3.349.754,6.736,1.539,13.755c1.045,9.352,2.128,19.051,3.24,29l-.2-.163,2.8-.3-.163.2c-.143-1.285-.3-2.674-.453-4.067-1.02-9.154-2.019-18.116-2.988-26.816q-.726-6.525-1.43-12.845-.175-1.58-.349-3.144a5.468,5.468,0,0,0-1.042-2.819,5.313,5.313,0,0,0-2.351-1.806,5.387,5.387,0,0,0-1.449-.327c-.487-.035-1.014-.013-1.52-.02l-23.4-.013-10.816-.008-5.164,0c-.424,0-.847,0-1.25.022a5.362,5.362,0,0,0-1.188.26,5.174,5.174,0,0,0-2.024,1.265,5.271,5.271,0,0,0-1.258,1.982,10.192,10.192,0,0,0-.427,2.307q-.289,2.344-.567,4.6-.556,4.5-1.064,8.612c-.679,5.476-1.29,10.411-1.827,14.737-1.084,8.635-1.862,14.831-2.267,18.052l-.03-.037,2.1.276c.46.063.689.1.689.1s-.214-.018-.673-.068l-2.126-.239-.033,0,0-.034c.384-3.224,1.121-9.425,2.149-18.067l1.777-14.743q.5-4.109,1.041-8.616.272-2.251.557-4.6a10.422,10.422,0,0,1,.436-2.369,5.548,5.548,0,0,1,1.318-2.087,5.467,5.467,0,0,1,2.131-1.337,5.687,5.687,0,0,1,1.254-.277c.434-.03.855-.027,1.277-.026l5.164,0,10.816-.008,23.4-.013c.515.006,1.01-.018,1.546.019a5.739,5.739,0,0,1,1.546.347,5.666,5.666,0,0,1,2.508,1.923,5.824,5.824,0,0,1,1.109,2.982q.175,1.565.352,3.144.706,6.315,1.437,12.846c.971,8.7,1.972,17.664,2.994,26.819.155,1.393.31,2.782.453,4.067l.02.182-.183.02-2.8.3-.181.02-.02-.182c-1.109-9.953-2.188-19.65-3.23-29q-.78-7.013-1.53-13.755-.187-1.684-.372-3.35a7.45,7.45,0,0,0-.26-1.6,2.508,2.508,0,0,0-.943-1.206,2.4,2.4,0,0,0-1.466-.415h-1.642l-3.253,0-24.441-.017-11.055-.011a5.706,5.706,0,0,0-1.284.067,2.467,2.467,0,0,0-1.082.575,2.606,2.606,0,0,0-.676,1.014,5.4,5.4,0,0,0-.224,1.227q-.313,2.533-.612,4.951c-1.6,12.877-2.9,23.27-3.792,30.452l-1.037,8.231-.274,2.129c-.063.478-.1.715-.1.715",
    transform: "translate(-51.717 -103.648)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138641",
    "data-name": "Path 138641",
    d: "M231.3,324.946a.9.9,0,0,1,.02.21,1.781,1.781,0,0,1-.033.622,3.046,3.046,0,0,1-1.375,1.918c-1.726,1.228-4.715,1.986-8.379,2.459-7.366.911-17.643.794-28.89-.266a10.23,10.23,0,0,1-4.078-1.105,5.5,5.5,0,0,1-2.459-3.269,19.12,19.12,0,0,1-.652-3.893q-.177-1.913-.346-3.742c-.418-4.877-.663-9.278-.8-12.977s-.168-6.693-.169-8.762c0-1.034.008-1.838.02-2.382.007-.256.013-.46.017-.619a.941.941,0,0,1,.018-.211.925.925,0,0,1,.02.211c0,.16.011.364.019.619.012.569.028,1.367.049,2.381.044,2.068.113,5.06.285,8.753s.439,8.089.875,12.958q.175,1.825.358,3.736a18.914,18.914,0,0,0,.645,3.82,5.136,5.136,0,0,0,2.3,3.062,9.91,9.91,0,0,0,3.934,1.056c11.217,1.058,21.481,1.215,28.819.374,3.65-.436,6.621-1.156,8.328-2.319a3.009,3.009,0,0,0,1.385-1.817,1.949,1.949,0,0,0,.068-.6.954.954,0,0,1,.018-.212",
    transform: "translate(-54.523 -86.734)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44514",
    "data-name": "Group 44514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44513",
    "data-name": "Group 44513",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138642",
    "data-name": "Path 138642",
    d: "M129.046,271.623c0,.425,3.968,15.731,3.968,20.691s-4.677,9.071-4.677,9.071l-5.1-11.054-2.126-13.747Z",
    transform: "translate(-35.86 -80.426)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138643",
    "data-name": "Path 138643",
    d: "M63.457,269.531c-.044.435.828,19.471.828,19.471l7.653-.709-1.7-12.755Z",
    transform: "translate(-18.789 -79.806)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138644",
    "data-name": "Path 138644",
    d: "M73.414,246.143c-.081.041-.32.116-.672.236-2.1.718-9.167,3.12-10.04,9.294l-.964,8.781,7.991,3.655.993,9.779,34.58.708-.85-8.219,11.741-2.582s-2.214-10.6-6.507-16.272a9.381,9.381,0,0,0-5.65-3.509l-17.867-3.573Z",
    transform: "translate(-18.28 -72.378)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138645",
    "data-name": "Path 138645",
    d: "M94.216,197.008a8.665,8.665,0,0,0-6.9,2.294,17.312,17.312,0,0,0-4.084,6.073,78.839,78.839,0,0,0-4.175,13.614c-1.644,6.8-3.294,13.642-3.732,20.613s1.721,11.089,4.835,17.392l11.013-1.473-.02-2.015,1.489,2.015,4.274-.639S98.2,244.089,98.2,244.121s2.039,10.281,2.039,10.281l3.562-.318c3.543-13.564-.465-22.489,1.55-36.341.479-3.295,1.238-6.572,1.224-9.9s-.9-6.8-3.279-9.213-6.477-3.394-9.4-1.625",
    transform: "translate(-22.286 -58.064)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138646",
    "data-name": "Path 138646",
    d: "M104.965,255.1a.789.789,0,0,1-.04-.155l-.092-.46c-.077-.42-.187-1.014-.327-1.771-.271-1.54-.645-3.773-.984-6.548a69.581,69.581,0,0,1-.555-9.8,52.363,52.363,0,0,1,.448-5.787,46.969,46.969,0,0,1,1.3-6.1c1.218-4.109,2.916-7.847,3.743-11.448a22.179,22.179,0,0,0,.653-5.169,13.888,13.888,0,0,0-.7-4.468,11.964,11.964,0,0,0-1.757-3.321,10.322,10.322,0,0,0-2.034-2.023,9.615,9.615,0,0,0-1.569-.949l-.44-.194a.821.821,0,0,1-.147-.074.853.853,0,0,1,.157.051l.451.173a8.84,8.84,0,0,1,1.607.917,10.2,10.2,0,0,1,2.087,2.018,11.972,11.972,0,0,1,1.813,3.347,13.975,13.975,0,0,1,.743,4.52,22.167,22.167,0,0,1-.634,5.219c-.822,3.63-2.518,7.378-3.727,11.465a47.342,47.342,0,0,0-1.3,6.07,53.163,53.163,0,0,0-.46,5.76,71.717,71.717,0,0,0,.5,9.777c.316,2.773.662,5.009.9,6.553.12.76.214,1.356.28,1.778.028.193.051.346.068.463a.749.749,0,0,1,.015.159",
    transform: "translate(-30.337 -58.279)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138647",
    "data-name": "Path 138647",
    d: "M83.769,249.017a.5.5,0,0,1-.025-.129c-.013-.1-.028-.224-.047-.38-.039-.352-.091-.842-.158-1.464q-.05-.479-.108-1.059c-.032-.388-.052-.81-.081-1.264-.049-.907-.135-1.939-.138-3.083q-.016-.857-.032-1.794c-.008-.624.021-1.273.031-1.946.006-1.346.113-2.78.2-4.29a81.25,81.25,0,0,1,3.845-19.286c.5-1.435.948-2.8,1.459-4.057.25-.628.472-1.241.719-1.818l.72-1.655c.443-1.062.92-1.989,1.313-2.814.2-.41.382-.8.561-1.144l.508-.944c.3-.553.539-.989.71-1.3l.19-.336a.531.531,0,0,1,.073-.111.472.472,0,0,1-.049.122l-.168.347-.667,1.323-.487.952-.541,1.151c-.381.829-.847,1.759-1.278,2.822l-.7,1.658c-.243.577-.46,1.191-.7,1.819-.5,1.252-.946,2.62-1.435,4.053a83.771,83.771,0,0,0-3.835,19.236c-.1,1.506-.212,2.935-.227,4.278-.015.671-.049,1.318-.046,1.941s.011,1.221.016,1.791c-.009,1.142.065,2.172.1,3.078q.032.678.06,1.263c.032.386.061.74.087,1.059l.111,1.467c.009.157.017.283.023.383a.492.492,0,0,1,0,.131",
    transform: "translate(-24.628 -59.261)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138648",
    "data-name": "Path 138648",
    d: "M91.3,259.447a.539.539,0,0,1-.051-.127l-.127-.382c-.111-.354-.267-.848-.464-1.477q-.149-.485-.329-1.069c-.118-.391-.213-.826-.333-1.287-.218-.928-.528-1.973-.73-3.157q-.171-.885-.358-1.85c-.132-.643-.2-1.322-.3-2.019-.086-.7-.225-1.419-.276-2.169s-.134-1.52-.2-2.31a72.024,72.024,0,0,1,.078-10.309,78.716,78.716,0,0,1,1.6-10.2q.279-1.158.544-2.257c.172-.732.4-1.43.582-2.111.367-1.365.79-2.613,1.166-3.755.356-1.149.77-2.158,1.093-3.057s.64-1.661.9-2.281l.6-1.429.163-.37a.616.616,0,0,1,.063-.122.54.54,0,0,1-.039.132l-.139.378-.558,1.444c-.248.625-.552,1.39-.861,2.293s-.712,1.913-1.057,3.063c-.364,1.143-.777,2.392-1.134,3.756-.181.681-.4,1.378-.569,2.109s-.35,1.482-.532,2.253a80.953,80.953,0,0,0-1.574,10.168,73.9,73.9,0,0,0-.1,10.275q.1,1.182.192,2.3c.047.748.182,1.465.263,2.163.1.7.162,1.374.289,2.015l.34,1.848c.191,1.183.488,2.228.693,3.158.113.462.2.9.312,1.29s.215.749.308,1.073c.178.633.317,1.131.418,1.488l.1.389a.554.554,0,0,1,.027.135",
    transform: "translate(-26.049 -61.503)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138649",
    "data-name": "Path 138649",
    d: "M111.358,249.509a.681.681,0,0,1-.076-.133l-.2-.4q-.133-.272-.318-.655l-.392-.913a32.253,32.253,0,0,1-1.844-6.035,33.179,33.179,0,0,1,.333-14.76c.46-1.864,1.064-3.757,1.679-5.693s1.206-3.83,1.636-5.689a27.529,27.529,0,0,0,.757-5.429,17,17,0,0,0-.523-4.913,12.574,12.574,0,0,0-1.8-3.924,11.246,11.246,0,0,0-4.823-4.037,10.405,10.405,0,0,0-1.676-.52l-.451-.089a.833.833,0,0,1-.153-.038.763.763,0,0,1,.156.013l.457.065a9.427,9.427,0,0,1,1.7.481,11.2,11.2,0,0,1,4.933,4.029,12.651,12.651,0,0,1,1.85,3.969,17.077,17.077,0,0,1,.553,4.969,27.55,27.55,0,0,1-.749,5.474c-.429,1.872-1.021,3.772-1.636,5.709s-1.219,3.824-1.68,5.678a33.451,33.451,0,0,0-.4,14.672,33.991,33.991,0,0,0,1.761,6.032l.37.919.295.664c.074.17.132.306.177.41a.662.662,0,0,1,.053.144",
    transform: "translate(-30.649 -58.117)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138650",
    "data-name": "Path 138650",
    d: "M70.759,262.787a12.729,12.729,0,0,1,.389,2.079l.773,5.033c.3,1.906.576,3.629.8,5.03a12.746,12.746,0,0,1,.263,2.1,11.521,11.521,0,0,1-.518-2.051c-.268-1.278-.6-3.051-.906-5.02s-.534-3.758-.668-5.057a11.519,11.519,0,0,1-.132-2.112",
    transform: "translate(-20.946 -77.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138651",
    "data-name": "Path 138651",
    d: "M123.023,266.614a58.548,58.548,0,0,1-.246,6.532,58.577,58.577,0,0,1-.612,6.508,58.349,58.349,0,0,1,.246-6.532,58.442,58.442,0,0,1,.612-6.508",
    transform: "translate(-36.161 -78.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138652",
    "data-name": "Path 138652",
    d: "M115.187,375.689l-3.961-12.618,9.107-2.763c-.061.019,3.007,15.834,3.007,15.834l-4.426,1.787Z",
    transform: "translate(-32.933 -106.685)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138653",
    "data-name": "Path 138653",
    d: "M133.7,382.982l-3.3-1.11-6.014-2.326-8.129.85,1.221,7.318,6.784-.548,11.529-.719-.229-.989a3.812,3.812,0,0,0-1.86-2.476",
    transform: "translate(-34.423 -112.381)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138654",
    "data-name": "Path 138654",
    d: "M128.952,386.549a17.376,17.376,0,0,1-.765-3.479,16.438,16.438,0,0,1-.4-3.524,35.061,35.061,0,0,1,1.161,7",
    transform: "translate(-37.829 -112.38)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138655",
    "data-name": "Path 138655",
    d: "M117.906,390.079l-.208-1.247,18.224-1.3.3,1.28Z",
    transform: "translate(-34.849 -114.745)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138656",
    "data-name": "Path 138656",
    d: "M82.955,404.645V392.482l10.062-.635-.631,13.1-4.78,1.868Z",
    transform: "translate(-24.562 -116.023)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138657",
    "data-name": "Path 138657",
    d: "M84.078,410.247l-4.006-.218s-6.165,4.989-6.759,7.726a6.143,6.143,0,0,0,0,2.1l9.361.272c1.885,0,6.829.008,6.829.008v-9.8Z",
    transform: "translate(-21.68 -121.407)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138658",
    "data-name": "Path 138658",
    d: "M101.591,350.225c.2.477,2.859,14.2,2.859,14.2l16.274-3.664-2.095-9.286Z",
    transform: "translate(-30.08 -103.699)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138659",
    "data-name": "Path 138659",
    d: "M77.723,352.2v28.388l15.973.681.695-29.069Z",
    transform: "translate(-23.013 -104.283)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18645",
    "data-name": "Rectangle 18645",
    width: 16.276,
    height: 1.699,
    transform: "translate(51.549 297.025)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138660",
    "data-name": "Path 138660",
    d: "M83.525,411.11c.1.03-.327,1.7-.664,3.795s-.469,3.813-.576,3.81a18.235,18.235,0,0,1,1.24-7.6",
    transform: "translate(-24.344 -121.727)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138661",
    "data-name": "Path 138661",
    d: "M91.731,419.7a8.545,8.545,0,0,0-.848-1.541,4.536,4.536,0,0,0-1.426-1.2,4.341,4.341,0,0,0-4.355.206,4.529,4.529,0,0,0-1.307,1.331,8.545,8.545,0,0,0-.7,1.613,1.041,1.041,0,0,1,.02-.489,4.081,4.081,0,0,1,.457-1.257A4.433,4.433,0,0,1,91.091,418a4.067,4.067,0,0,1,.574,1.209,1.029,1.029,0,0,1,.066.486",
    transform: "translate(-24.599 -123.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138662",
    "data-name": "Path 138662",
    d: "M70.6,332.493a9.388,9.388,0,0,1-9.407-9.092c-.26-9.522-.267-24.269-.256-30.664a3.14,3.14,0,0,1,3.144-3.135H113a3.14,3.14,0,0,1,3.143,3.215c-.16,6.638-.535,22.035-.767,31.579a8.3,8.3,0,0,1-8.3,8.1Z",
    transform: "translate(-18.041 -85.749)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138663",
    "data-name": "Path 138663",
    d: "M57.682,402.615l-2.8-.341,5.76-47.125a5.468,5.468,0,0,1,5.386-4.851h41.256a5.471,5.471,0,0,1,5.384,4.832c1.38,11.14,5.222,46.8,5.26,47.163l-2.8.3c-.039-.359-3.879-36-5.256-47.118a2.651,2.651,0,0,0-2.59-2.363H66.033a2.651,2.651,0,0,0-2.59,2.374Z",
    transform: "translate(-16.252 -103.721)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138664",
    "data-name": "Path 138664",
    d: "M57.666,402.542s.023-.257.078-.744.14-1.213.25-2.155c.225-1.9.555-4.68.98-8.269.86-7.173,2.1-17.551,3.648-30.412q.291-2.41.6-4.934a5.6,5.6,0,0,1,.235-1.285,2.874,2.874,0,0,1,.744-1.121,2.733,2.733,0,0,1,1.2-.643,5.944,5.944,0,0,1,1.349-.077l11.054-.01,24.441-.018h4.894a2.754,2.754,0,0,1,1.656.472,2.845,2.845,0,0,1,1.072,1.367,7.652,7.652,0,0,1,.281,1.683q.186,1.665.375,3.349.754,6.736,1.539,13.755c1.045,9.352,2.128,19.051,3.24,29l-.2-.163,2.8-.3-.163.2c-.143-1.285-.3-2.674-.453-4.067-1.02-9.154-2.019-18.116-2.988-26.816q-.726-6.525-1.43-12.845-.175-1.58-.349-3.144a5.468,5.468,0,0,0-1.042-2.819,5.313,5.313,0,0,0-2.351-1.806,5.387,5.387,0,0,0-1.449-.327c-.487-.035-1.014-.013-1.52-.02l-23.4-.013-10.816-.008-5.164,0c-.424,0-.847,0-1.25.022a5.362,5.362,0,0,0-1.188.26,5.174,5.174,0,0,0-2.024,1.265,5.271,5.271,0,0,0-1.258,1.982,10.192,10.192,0,0,0-.427,2.307q-.289,2.344-.567,4.6-.556,4.5-1.064,8.612c-.679,5.476-1.29,10.411-1.827,14.737-1.084,8.635-1.862,14.831-2.267,18.052l-.03-.037,2.1.276c.46.063.689.1.689.1s-.214-.018-.673-.068l-2.126-.239-.034,0,0-.034c.384-3.224,1.121-9.425,2.149-18.067.522-4.328,1.116-9.265,1.777-14.743q.5-4.109,1.041-8.616.272-2.251.557-4.6a10.424,10.424,0,0,1,.436-2.369,5.556,5.556,0,0,1,1.318-2.087,5.467,5.467,0,0,1,2.131-1.337,5.687,5.687,0,0,1,1.254-.277c.434-.03.855-.027,1.277-.026l5.164,0,10.816-.008,23.4-.013c.515.006,1.01-.018,1.546.019a5.739,5.739,0,0,1,1.546.347,5.666,5.666,0,0,1,2.508,1.923,5.824,5.824,0,0,1,1.109,2.982q.175,1.565.352,3.144.706,6.315,1.437,12.846c.971,8.7,1.972,17.664,2.994,26.819.155,1.393.31,2.782.453,4.067l.02.182-.183.02-2.8.3-.182.02-.02-.182c-1.109-9.953-2.188-19.65-3.23-29q-.78-7.013-1.53-13.755-.187-1.684-.372-3.35a7.448,7.448,0,0,0-.26-1.6,2.508,2.508,0,0,0-.943-1.206,2.4,2.4,0,0,0-1.466-.415H105.5l-3.253,0L77.8,353.191l-11.054-.011a5.71,5.71,0,0,0-1.285.067,2.468,2.468,0,0,0-1.082.575,2.606,2.606,0,0,0-.676,1.014,5.4,5.4,0,0,0-.224,1.227q-.313,2.533-.612,4.951c-1.6,12.877-2.9,23.27-3.792,30.452-.45,3.572-.8,6.343-1.037,8.231l-.274,2.129c-.063.478-.1.715-.1.715",
    transform: "translate(-16.236 -103.648)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138665",
    "data-name": "Path 138665",
    d: "M111.468,324.946a.9.9,0,0,1,.02.21,1.782,1.782,0,0,1-.033.622,3.046,3.046,0,0,1-1.375,1.918c-1.726,1.228-4.715,1.986-8.379,2.459-7.366.911-17.643.794-28.89-.266a10.223,10.223,0,0,1-4.078-1.105,5.5,5.5,0,0,1-2.46-3.269,19.12,19.12,0,0,1-.652-3.893q-.177-1.913-.346-3.742c-.418-4.877-.663-9.278-.8-12.977s-.168-6.693-.169-8.762c0-1.034.008-1.838.02-2.382.006-.256.012-.46.016-.619a.942.942,0,0,1,.018-.211.925.925,0,0,1,.02.211c0,.16.011.364.019.619.012.569.028,1.367.049,2.381.045,2.068.113,5.06.285,8.753s.439,8.089.875,12.958q.175,1.825.358,3.736a18.915,18.915,0,0,0,.645,3.82,5.136,5.136,0,0,0,2.3,3.062,9.91,9.91,0,0,0,3.934,1.056c11.217,1.058,21.481,1.215,28.819.374,3.65-.436,6.621-1.156,8.328-2.319a3.009,3.009,0,0,0,1.385-1.817,1.949,1.949,0,0,0,.068-.6.955.955,0,0,1,.018-.212",
    transform: "translate(-19.041 -86.734)",
    fill: "#263238"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup152);
export default __webpack_public_path__ + "static/media/mask-group-152.9d01336f22968d6443428af06bfe9fb3.svg";
export { ForwardRef as ReactComponent };